const mt=document.getElementById('mtrack');
mt.innerHTML=mt.innerHTML+mt.innerHTML;
/* v13.6 · scrolling chips del #stays "For larger organisations" · mismo
   pattern del marquee del hero: duplicar el innerHTML del track para que
   el translateX -50% de la animación wrappee sin cortes visibles. Skip
   defensivo si el elemento no existe (safety para vistas non-home). */
const et=document.getElementById('etrack');
if(et){ et.innerHTML=et.innerHTML+et.innerHTML; }
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in'); io.unobserve(e.target);}}),{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));
const steps=[];
const tend=document.querySelector('.tend');
const rp=document.getElementById('railprogress');
function railTo(el){
  /* the line fills left to right: to the centre of whichever step has arrived */
  const rail=el.closest('.rail'); if(!rail) return;
  const rr=rail.getBoundingClientRect();
  const er=el.getBoundingClientRect();
  const w=Math.min(rr.width, Math.max(0, (er.left - rr.left) + er.width/2));
  rp.style.width=(el.classList.contains('tend') ? rr.width : w)+'px';
}
const tio=new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){
    e.target.classList.add('in');
    railTo(e.target);
    if(e.target===steps[steps.length-1]) setTimeout(()=>{tend.classList.add('in'); railTo(tend);},350);
    tio.unobserve(e.target);
  }
}),{threshold:.55});
steps.forEach(s=>tio.observe(s));
const dbtns=[...document.querySelectorAll('.dbtn')];
const dpanels=[...document.querySelectorAll('.dpanel')];
const glayers=[...document.querySelectorAll('.dlayer')];
/* v18.5 · dparts · SVG polygons + labels dentro del .dpicksvg que tienen data-d="N"
   para que reaccionen al depth activo con .on toggle (highlight vs disabled fade).
   Reemplaza el behavior cumulativo del .dlayer approach (era `<= +d`, todas las capas
   hasta la activa se prendían — para el old "progressive fill" look). Nuevo behavior
   es MATCH-ONLY (solo la depth activa gana .on, las otras quedan sin .on = dimmed).
   Feedback Design 2: "cuando el usuario cambia de tab, el octagon correspondiente
   debe highlight y los otros van a disabled pero siguen visibles". */
const dparts=[...document.querySelectorAll('#depths .dpicksvg [data-d]')];
/* v12.4 · dlegs removed (the legend inside .dgauge se migró al .dyield dentro de cada
   .dpanel, activación bindeada por .dpanel.active sin lógica extra). */
function setDepth(d){
  dbtns.forEach(b=>{const on=b.dataset.d===d; b.classList.toggle('active',on); b.setAttribute('aria-selected',on);});
  dpanels.forEach(p=>p.classList.toggle('active',p.dataset.d===d));
  glayers.forEach(g=>g.classList.toggle('on', +(g.dataset.d||0) <= +d));  /* no-op post v18.4 · glayers=[] */
  dparts.forEach(el=>el.classList.toggle('on', el.dataset.d === d));  /* v18.5 · match-only highlight */
}
dbtns.forEach(b=>b.addEventListener('click',()=>setDepth(b.dataset.d)));
setDepth('1');
const RM=matchMedia('(prefers-reduced-motion: reduce)').matches;
function pickOpt(el){[...el.parentElement.children].forEach(c=>c.classList.remove('sel')); el.classList.add('sel');}
// count-up numbers
const counts=[...document.querySelectorAll('[data-count]')];
const cio=new IntersectionObserver(es=>es.forEach(e=>{
  if(e.isIntersecting){runCount(e.target); cio.unobserve(e.target);}
}),{threshold:.6});
counts.forEach(el=>{if(RM){el.textContent=el.dataset.count;}else{el.textContent='0'; cio.observe(el);}});
function runCount(el){
  const to=+el.dataset.count, dur=1100, t0=performance.now();
  (function f(t){
    const p=Math.min(1,(t-t0)/dur);
    el.textContent=Math.round(to*(1-Math.pow(1-p,3)));
    if(p<1)requestAnimationFrame(f);
  })(t0);
}
// chat thread plays when seen
const chat=document.querySelector('#why .chatcard');
if(chat){
  const wio=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){chat.classList.add('play'); wio.disconnect();}
  }),{threshold:.45});
  wio.observe(chat);
}
// the cancelled board: rows flip one at a time, then hold
const fb=document.getElementById('failboard');
if(fb){
  const fio=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting){
      [...fb.querySelectorAll('.fb-row:not(.fb-head)')].forEach((r,i)=>{
        setTimeout(()=>r.classList.add('flip'), RM?0:400+i*480);
      });
      fio.disconnect();
    }
  }),{threshold:.35});
  fio.observe(fb);
}

const mio=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('draw'); mio.unobserve(e.target);}}),{threshold:.6});
document.querySelectorAll('.metaline').forEach(el=>mio.observe(el));
// router: direct page swap. Works in sandboxed viewers where hash navigation is blocked.
const RMG=matchMedia('(prefers-reduced-motion: reduce)').matches;
/* the reading hairline runs on the same frame-sampled drive as the slides */
(function(){
  const bar=document.getElementById('readbar'); if(!bar) return;
  (function frame(){
    if(!document.hidden){
      const max=document.documentElement.scrollHeight-innerHeight;
      bar.style.transform='scaleX('+(max>0?Math.min(1,scrollY/max):0)+')';
    }
    requestAnimationFrame(frame);
  })();
})();
const pages={home:document.getElementById('page-home'), mission:document.getElementById('page-mission'), news:document.getElementById('page-news'), start:document.getElementById('page-start'), book:document.getElementById('page-book'), article:document.getElementById('page-article')};
function showPage(name, anchor, slug){
  const target=pages[name]||pages.home;
  Object.values(pages).forEach(p=>p.classList.remove('active'));
  target.classList.add('active');
  // v5.2 · article routing · toggle .on on the matching .a-content[data-slug]
  if(name==='article' && slug){
    target.querySelectorAll('.a-content').forEach(s=>s.classList.remove('on'));
    const shell=target.querySelector('.a-content[data-slug="'+slug+'"]');
    if(shell){ shell.classList.add('on'); }
    try{ history.replaceState(null,'', '#/news/'+slug); }catch(e){}
  } else {
    try{ history.replaceState(null,'', '#/'+(name==='home'?'':name)); }catch(e){}
  }
  target.querySelectorAll('.reveal:not(.in)').forEach(el=>io.observe(el));
  target.querySelectorAll('.metaline:not(.draw)').forEach(el=>mio.observe(el));
  if(anchor){
    requestAnimationFrame(()=>{const el=document.querySelector(anchor); if(el)el.scrollIntoView({block:'start', behavior:RMG?'auto':'smooth'});});
  } else {
    window.scrollTo(0,0);
  }
}
const _origShow=showPage;
// v5.2 · click handler · detect 2-segment routes like #/news/[slug] and dispatch to article
document.querySelectorAll('[data-route]').forEach(a=>{
  a.addEventListener('click',e=>{
    e.preventDefault();
    const href=a.getAttribute('href')||'#/';
    if(href==='#/'){ showPage('home'); return; }
    const parts=href.replace('#/','').split('/').filter(Boolean);
    if(parts.length===2 && parts[0]==='news'){
      showPage('article', null, parts[1]);
    } else {
      showPage(parts[0]);
    }
  });
});
// v5.2 · make the MIT card clickable · direct navigation to its article shell
document.querySelectorAll('#page-news .ncard[data-slug]').forEach(card=>{
  card.classList.add('linked');
  card.addEventListener('click',()=>{
    showPage('article', null, card.dataset.slug);
  });
  card.addEventListener('keydown',e=>{
    if(e.key==='Enter'||e.key===' '){ e.preventDefault(); showPage('article', null, card.dataset.slug); }
  });
  card.setAttribute('role','link');
  card.setAttribute('tabindex','0');
});
document.querySelectorAll('[data-home-anchor]').forEach(a=>{
  a.addEventListener('click',e=>{
    e.preventDefault();
    const anchor=a.getAttribute('href');
    if(pages.home.classList.contains('active')){
      const el=document.querySelector(anchor); if(el)el.scrollIntoView({block:'start', behavior:RMG?'auto':'smooth'});
    } else { showPage('home', anchor); }
  });
});
// v5.2 · initial route parsing · si el user aterriza con #/news/[slug] o #/mission etc, respetalo
(function(){
  const h=location.hash||'#/';
  if(h==='#/'||h==='#'){ showPage('home'); return; }
  const parts=h.replace('#/','').split('/').filter(Boolean);
  if(parts.length===2 && parts[0]==='news'){
    showPage('article', null, parts[1]);
  } else if(parts[0] && pages[parts[0]]){
    showPage(parts[0]);
  } else {
    showPage('home');
  }
})();
// metalines outside .reveal wrappers draw on their own
// hero eases back as you scroll past it
const heroLeft=document.querySelector('.hero .grid > div:first-child');
if(heroLeft && !RM){
  addEventListener('scroll',()=>{
    if(!pages.home.classList.contains('active'))return;
    const y=Math.min(scrollY,520);
    heroLeft.style.transform=`translateY(${y*0.10}px)`;
    heroLeft.style.opacity=String(1-y/820);
  },{passive:true});
}

/* ===================== THE VAULT =====================
   Built to the assessment-funnel standard. */
const VSTORE='https://octaflow.com';
const VHANDLES={"OF-C04": "capital-readiness-and-evidence-system-of-c04", "OF-C08": "self-improving-operating-model-of-c08", "OF-C13": "revenue-recovery-operating-system-of-c13", "OF-F01": "ai-governance-framework-design-of-f01", "OF-F02": "ai-roi-measurement-and-business-case-of-f02", "OF-F07": "ai-agent-design-and-deployment-of-f07", "OF-F08": "ai-risk-assessment-for-operations-of-f08", "OF-F14": "ai-assisted-forecasting-methodology-of-f14", "OF-F15": "compliance-and-regulatory-documentation-of-f15", "OF-F16": "risk-registers-of-f16", "OF-F24": "financial-controls-and-policies-of-f24", "OF-F29": "sales-playbook-design-of-f29", "OF-F31": "sales-to-delivery-handover-documentation-of-f31", "OF-G026": "financial-close-acceleration-system-of-g026", "OF-G076": "critical-person-dependency-system-of-g076", "OF-G080": "company-knowledge-architecture-of-g080", "OF-G081": "standard-operating-procedure-system-of-g081", "OF-G082": "expert-knowledge-capture-system-of-g082", "OF-G093": "customer-onboarding-operating-system-of-g093", "OF-G094": "customer-adoption-system-of-g094", "OF-G098": "churn-prevention-and-rescue-system-of-g098", "OF-G103": "customer-service-recovery-system-of-g103", "OF-G108": "knowledge-work-quality-assurance-system-of-g108", "OF-G110": "incident-and-problem-management-system-of-g110", "OF-G133": "company-data-governance-system-of-g133", "OF-G167": "policy-lifecycle-management-system-of-g167", "OF-S08": "operating-model-optimisation-system-of-s08", "OF-S14": "sales-conversion-improvement-system-of-s14", "OF-S23": "pricing-and-margin-check-of-s23", "OF-S44": "audit-readiness-system-of-s44"};
/* ============ THE VAULT · CONFIG ============
   Catalogue and prices from OCTAFLOW_295_PRODUCT_SHOPIFY_IMPORT, 885 variants.
   All 295 products are priced at all three layers, so any product is routable.
   p:[layer1, layer2, layer3] matches the Shopify variant prices exactly.
   Axis two uses two guards: a depth ceiling by revenue, and a hard money ceiling
   by revenue, because a layer two ranges from $6,000 to $12,000. */
const CONFIG = {
  intro: {
    // v17.1 · Design 2 rework 2026-08-12: h1 unchanged; lead shortened (drops "Five questions… over coffee." opener); CTA → "Start Questionnaire"; pills unchanged.
    eyebrow: 'A five-minute consultation',
    h1: 'Tell us what is going wrong. We will tell you how to fix it.',
    hlPhrase: 'how to fix it.',
    lead: 'At the end you get the three things we would do about it, what each one costs, and where we would start.',
    pills: ['Free', 'No account needed', 'About five minutes'],
    cta: 'Start Questionnaire'
  },
  depths: [
    {key:'answer', name:'The answer',
     what:'We work out what to do and hand you the plan. Your team runs it.'},
    {key:'method', name:'The working method',
     what:'We build it, test it on your real work, and show your team how to run it.'},
    {key:'system', name:'The full system',
     what:'We design and build the whole thing across your tools and teams, then hand you the keys.'}
  ],
  catalogue: {
    t_gov:{name:"Rules for using AI", ref:'OF-F01', p:[2500,7500,35000],
      demo:"Who is allowed to use AI for what, written down, with a named person answerable for each decision."},
    t_risk:{name:"Deciding which AI uses are safe", ref:'OF-F08', p:[2500,7500,38000],
      demo:"One test you run before saying yes to any new AI use, so the answer is the same whoever asks."},
    t_agent:{name:"AI agents that behave", ref:'OF-F07', p:[3500,12000,50000],
      demo:"Agents with limits you set: what they can touch, what they must never do, and when a person takes over."},
    t_data:{name:"Getting your data straight", ref:'OF-G133', p:[3500,12000,50000],
      demo:"Who owns which numbers, what they mean, and how a wrong one gets fixed rather than argued about."},
    t_roi:{name:"Working out if the AI is worth it", ref:'OF-F02', p:[2000,6000,28000],
      demo:"What the AI tools are costing you, what they are giving back, and which ones to stop paying for."},
    f_price:{name:"Checking your prices and margins", ref:'OF-S23', p:[2000,6000,30000],
      demo:"What a job really costs you, what it is worth to the buyer, and what your price should be."},
    f_fcast:{name:"A forecast people believe", ref:'OF-F14', p:[3000,9000,40000],
      demo:"AI does the scenarios. Every assumption and override stays visible, so the number can be defended."},
    f_ctrl:{name:"Financial controls that hold", ref:'OF-F24', p:[2000,6500,32000],
      demo:"The approvals, limits and checks your close depends on, written down and actually followed."},
    f_close:{name:"Month end that stops eating the month", ref:'OF-G026', p:[3000,10000,45000],
      demo:"The close, taken apart and put back together so it finishes in days rather than weeks."},
    f_sys:{name:"Ready for a board or a funder", ref:'OF-C04', p:[3000,10000,45000],
      demo:"The numbers, the evidence behind them and the story they tell, in a state that survives questioning."},
    d_qa:{name:"What good work looks like", ref:'OF-G108', p:[3000,9000,40000],
      demo:"A written standard for the work and a check that catches a problem before the customer does."},
    d_inc:{name:"Stopping the same failure twice", ref:'OF-G110', p:[3000,10000,45000],
      demo:"Who does what when it breaks, and a route that fixes the cause instead of the symptom."},
    d_opt:{name:"Finding where the work jams", ref:'OF-S08', p:[3000,10000,45000],
      demo:"Where the work slows, doubles back or waits, and what to change first."},
    d_self:{name:"A business that learns as it works", ref:'OF-C08', p:[3500,12000,50000],
      demo:"The whole way you work, rebuilt so every fix sticks and the next month starts easier."},
    s_hand:{name:"Closing the gap between sale and delivery", ref:'OF-F31', p:[2000,6500,30000],
      demo:"Where the promise gets lost on the way to the people doing the work, and what it costs you."},
    s_play:{name:"A way of selling anyone can follow", ref:'OF-F29', p:[2000,6500,30000],
      demo:"How your best salesperson does it, written down so the next hire can do it too."},
    s_conv:{name:"Turning more talks into deals", ref:'OF-S14', p:[2500,9000,40000],
      demo:"Which deals are real, which are not, and what has to happen next on each one."},
    s_rev:{name:"Finding the money already in the business", ref:'OF-C13', p:[3500,12000,50000],
      demo:"The revenue you have already earned and lost track of, and the system that stops it happening again."},
    g_reg:{name:"A risk list that does something", ref:'OF-F16', p:[2000,6000,28000],
      demo:"Risks with an owner, a plan and a date, instead of a spreadsheet nobody opens."},
    g_pol:{name:"Policies people actually follow", ref:'OF-G167', p:[2500,7500,35000],
      demo:"Policies that reach the right people, get read, get signed off, and stay up to date."},
    g_doc:{name:"Paperwork that holds up", ref:'OF-F15', p:[3000,9000,40000],
      demo:"The compliance record written so it answers the question the first time it is asked."},
    g_audit:{name:"Ready for the audit before it starts", ref:'OF-S44', p:[3000,10000,45000],
      demo:"The evidence an auditor or a client will ask for, gathered and kept current in advance."},
    k_arch:{name:"Somewhere to look things up", ref:'OF-G080', p:[2500,8500,40000],
      demo:"One place where people, and any AI you use, can find the right answer and trust it."},
    k_sop:{name:"Writing down how the work is done", ref:'OF-G081', p:[2500,7500,35000],
      demo:"The steps your team follows, written once, so nobody has to explain them again."},
    k_exp:{name:"Keeping what your best people know", ref:'OF-G082', p:[2500,7500,35000],
      demo:"What lives in a few heads, captured and held by the company before those people leave."},
    k_person:{name:"When too much rests on one person", ref:'OF-G076', p:[2500,7500,35000],
      demo:"The jobs only one person can do, and a way to spread them before that person leaves."},
    c_adopt:{name:"Getting customers actually using it", ref:'OF-G094', p:[2500,7500,35000],
      demo:"Where new customers stall after signing, and what makes the habit stick."},
    c_recover:{name:"Putting it right when it goes wrong", ref:'OF-G103', p:[2500,7500,35000],
      demo:"What happens after a complaint, so the customer stays and the cause gets fixed."},
    c_churn:{name:"Keeping the customers you have", ref:'OF-G098', p:[3000,10000,45000],
      demo:"Spotting the ones about to leave, and the play that brings them back."},
    c_onboard:{name:"Getting new customers started properly", ref:'OF-G093', p:[2000,7500,32000],
      demo:"The first ninety days, run the same good way every time."},
  },
  categories: {
    tech:{name:'AI and data', diagnostic:'t_roi',
      triggers:{
        unchecked:{hero:'t_gov', supports:['t_risk','t_roi']},
        agents:{hero:'t_agent', supports:['t_risk','t_gov']},
        asked:{hero:'t_risk', supports:['t_gov','t_roi']},
        data:{hero:'t_data', supports:['t_gov','t_roi']},
        _default:{hero:'t_gov', supports:['t_risk','t_roi']}},
      qs:[["People are using AI and nobody signed it off",'unchecked'],
          ["We built something with AI and it keeps getting things wrong",'agents'],
          ["Someone is about to ask us how we use AI",'asked'],
          ["Our data is too messy to trust",'data']]},
    finance:{name:'Money and numbers', diagnostic:'f_price',
      triggers:{
        forecast:{hero:'f_fcast', supports:['f_ctrl','f_price']},
        margin:{hero:'f_price', supports:['f_ctrl','f_fcast']},
        close:{hero:'f_close', supports:['f_ctrl','f_price']},
        raise:{hero:'f_sys', supports:['f_fcast','f_ctrl']},
        _default:{hero:'f_fcast', supports:['f_price','f_ctrl']}},
      qs:[["Nobody believes the forecast",'forecast'],
          ["We are not sure we are making money on what we sell",'margin'],
          ["Month end takes over the whole month",'close'],
          ["A board or a funder is about to go through our numbers",'raise']]},
    delivery:{name:'How the work gets done', diagnostic:'d_qa',
      triggers:{
        repeat:{hero:'d_inc', supports:['d_qa','d_opt']},
        quality:{hero:'d_qa', supports:['d_inc','d_opt']},
        jams:{hero:'d_opt', supports:['d_qa','d_inc']},
        scale:{hero:'d_self', supports:['d_qa','d_opt']},
        _default:{hero:'d_qa', supports:['d_inc','d_opt']}},
      qs:[["The same problems keep coming back",'repeat'],
          ["The quality depends on who happens to do it",'quality'],
          ["Everything takes longer than it should",'jams'],
          ["How we work will not survive us getting bigger",'scale']]},
    sales:{name:'Selling and delivering', diagnostic:'s_hand',
      triggers:{
        leak:{hero:'s_hand', supports:['s_play','s_conv']},
        stall:{hero:'s_conv', supports:['s_hand','s_play']},
        people:{hero:'s_play', supports:['s_hand','s_conv']},
        revenue:{hero:'s_rev', supports:['s_conv','s_hand']},
        _default:{hero:'s_conv', supports:['s_hand','s_play']}},
      qs:[["What we sell and what we deliver are two different things",'leak'],
          ["Deals go quiet and we never know why",'stall'],
          ["Only one person here can really sell",'people'],
          ["We think we are losing money we have already earned",'revenue']]},
    customer:{name:'Keeping customers', diagnostic:'c_onboard',
      triggers:{
        start:{hero:'c_onboard', supports:['c_adopt','c_recover']},
        stall:{hero:'c_adopt', supports:['c_onboard','c_churn']},
        leave:{hero:'c_churn', supports:['c_adopt','c_recover']},
        complain:{hero:'c_recover', supports:['c_churn','c_onboard']},
        _default:{hero:'c_onboard', supports:['c_adopt','c_churn']}},
      qs:[["New customers take too long to get going",'start'],
          ["They sign up and then never really use it",'stall'],
          ["Customers leave and we find out too late",'leave'],
          ["Complaints get handled and then happen again",'complain']]},
    gov:{name:'Proving what you do', diagnostic:'g_reg',
      triggers:{
        audit:{hero:'g_audit', supports:['g_reg','g_doc']},
        risk:{hero:'g_reg', supports:['g_audit','g_pol']},
        policy:{hero:'g_pol', supports:['g_reg','g_doc']},
        paperwork:{hero:'g_doc', supports:['g_reg','g_audit']},
        _default:{hero:'g_reg', supports:['g_audit','g_pol']}},
      qs:[["An audit or a big client review is coming",'audit'],
          ["We write risks down and then nothing happens",'risk'],
          ["We have policies and nobody follows them",'policy'],
          ["Every request for evidence turns into a scramble",'paperwork']]},
    knowledge:{name:'What your company knows', diagnostic:'k_sop',
      triggers:{
        find:{hero:'k_arch', supports:['k_sop','k_exp']},
        people:{hero:'k_person', supports:['k_exp','k_sop']},
        leaver:{hero:'k_exp', supports:['k_arch','k_person']},
        sop:{hero:'k_sop', supports:['k_arch','k_exp']},
        _default:{hero:'k_sop', supports:['k_arch','k_exp']}},
      qs:[["Nobody can tell which version is the right one",'find'],
          ["Too much of it is in one or two people's heads",'people'],
          ["When someone leaves, we lose what they knew",'leaver'],
          ["We explain the same thing over and over",'sop']]}
  },
  symptoms:[
    ["We are using AI and it is not paying off",'tech'],
    ["We cannot trust our own numbers",'finance'],
    ["The same things keep going wrong",'delivery'],
    ["We sell one thing and deliver another",'sales'],
    ["Customers go quiet, then go elsewhere",'customer'],
    ["We cannot prove what we do",'gov'],
    ["Everything important is in someone's head",'knowledge']
  ],
  size:[
    ["Under $1M",'u1m'], ["$1M to $5M",'u5m'], ["$5M to $20M",'u20m'], ["Over $20M",'o20m']
  ],
  sizeCeiling:{u1m:0, u5m:1, u20m:1, o20m:2},
  sizeCap:    {u1m:1, u5m:1, u20m:2, o20m:2},
  moneyCap:   {u1m:8000, u5m:12000, u20m:50000, o20m:999999},
  intent:[
    ["Steady as we are",'steady'], ["Growing carefully",'careful'],
    ["Growing fast",'scaling'], ["Raising money, selling or restructuring",'raise']
  ],
  intentLift:['scaling','raise'],
  maturity:[
    ["Nothing. It is all in people's heads",'none'],
    ["Bits and pieces",'some'],
    ["It is written down and people follow it",'mature']
  ]
};

/* ---------- signature progress: pentagon meter (5 sides = 5 questions) ---------- */
/* v17.1 · Design 2 · pentágono progresivo · 1 lado por pregunta respondida.
   Al 5/5 el wrapper .octo-swap gana .done y revela el isotype Octaflow (Spark) — el octógono sigue siendo brand mark. */
function pentaVerts(cx,cy,r){const v=[];for(let i=0;i<5;i++){const a=(-90+i*72)*Math.PI/180;v.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}return v;}
function buildPenta(svg,r,withDot){
  const v=pentaVerts(50,50,r);let s='';
  for(let i=0;i<5;i++){const a=v[i],b=v[(i+1)%5];s+=`<line x1="${a[0].toFixed(1)}" y1="${a[1].toFixed(1)}" x2="${b[0].toFixed(1)}" y2="${b[1].toFixed(1)}"/>`;}
  if(withDot)s+=`<circle class="dot" cx="50" cy="50" r="7" fill="var(--spark)"/>`;
  svg.innerHTML=s;
}
const penta=document.getElementById('penta');
buildPenta(penta,38,true);
const VTOTAL=5;
const octoSwap=document.querySelector('.octo-swap');
function setProgress(answered){
  // 1 lado por pregunta respondida · 5/5 = todos los lados en espresso + swap al isotype
  penta.querySelectorAll('line').forEach((l,i)=>l.classList.toggle('lit',i<answered));
  penta.querySelector('.dot').classList.toggle('on',answered>=VTOTAL);
  if(octoSwap)octoSwap.classList.toggle('done',answered>=VTOTAL);
  const sub=document.getElementById('vsub');
  sub.textContent = answered>=VTOTAL ? 'Your results' : (answered===0 ? 'Five questions' : 'Question '+(answered+1)+' of '+VTOTAL);
}
setProgress(0);

/* ---------- state + panel ---------- */
const vstate={cat:null,trigger:null,size:null,intent:null,maturity:null,email:null};
const vstage=document.getElementById('stage');
let vstep=0;
function vpanel(html){
  const p=document.createElement('div');p.className='vpanel';p.innerHTML=html;
  vstage.innerHTML='';vstage.appendChild(p);requestAnimationFrame(()=>p.classList.add('show'));
  const f=p.querySelector('[autofocus]')||p.querySelector('.vopt,.vbtn,input');
  if(f&&vstep>0)setTimeout(()=>f.focus({preventScroll:true}),120);
  return p;
}
function voptsHTML(list){
  const tick='<svg class="vtick" viewBox="0 0 20 20" aria-hidden="true"><polygon class="vtick-ring" points="6,1 14,1 19,6 19,14 14,19 6,19 1,14 1,6"/></svg>';
  return '<div class="vopts" role="list">'+list.map((o,i)=>`<button class="vopt" role="listitem" data-i="${i}">${tick}<span>${o[0]}</span></button>`).join('')+'</div>';
}
function vfooter(back,hint){return `<div class="vfoot"><button class="vback" ${back?'':'disabled'}>Back</button><span class="vhint">${hint||''}</span></div>`;}
function vwire(p,list,cb){
  p.querySelectorAll('.vopt').forEach(btn=>{
    btn.onclick=()=>{p.querySelectorAll('.vopt').forEach(b=>b.classList.remove('sel'));btn.classList.add('sel');setTimeout(()=>cb(list[+btn.dataset.i]),RM?0:320);};
  });
}
function vback(p,cb){const b=p.querySelector('.vback');if(b&&!b.disabled)b.onclick=cb;}

/* ---------- the consultation ---------- */
/* v17.1 · Design 2 · /start intake intro redesign (Figma 383:36 · 2026-08-12).
   Layout: 2-col grid (.vpanel--intro) — text left (pills row · h1 · lead · Start Questionnaire) + pentagon graphic right.
   Pills row keeps 3 tokens but the register flips from muted-line to colored-bg (Spark/Mocha/Espresso).
   H1 mixes weights: "Tell us what is going wrong. We will tell you" in Bold 700, "how to fix it." in ExtraBold 800 + Spark.
   Pentagon graphic 505×402: 3 concentric outlines + 5 octagonal touchpoints at vertices + Spark accent side v4→v0 +
   tick marks + center "5." with Spark period + "QUESTIONS" caption + 5 vertex labels (01 in Spark with "START HERE" caption).
   Geometry: point-up pentagon, center (252.70, 218.94), outer R=157.30 · vertices at (-90+i·72)°. */
function vIntro(){
  setProgress(0);
  const c=CONFIG.intro;
  // Icons for pills — line-style SVG, currentColor stroke (inherits Canvas from pill bg)
  const iconFree='<svg viewBox="0 0 20 20" aria-hidden="true" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="9" width="14" height="8"/><rect x="2" y="6" width="16" height="3"/><line x1="10" y1="6" x2="10" y2="17"/><path d="M10 6c-1-3-4-3-4-1s3 1 4 1"/><path d="M10 6c1-3 4-3 4-1s-3 1-4 1"/></svg>';
  const iconAcct='<svg viewBox="0 0 20 20" aria-hidden="true" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="7" r="3.2"/><path d="M4 17c0-3.4 2.7-5.7 6-5.7s6 2.3 6 5.7"/></svg>';
  const iconClock='<svg viewBox="0 0 20 20" aria-hidden="true" fill="none" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><circle cx="10" cy="10" r="7.5"/><path d="M10 5.8V10l2.8 2.2"/></svg>';
  const icons=[iconFree,iconAcct,iconClock];
  const pillMods=['pill-free','pill-acct','pill-time'];
  // H1 · natural wrap dentro del col width 512.83 · Bold para primer segmento, ExtraBold+Spark en hlPhrase
  const hlIx = c.h1.indexOf(c.hlPhrase);
  const h1HTML = hlIx>=0
    ? `${c.h1.slice(0,hlIx)}<span class="hl">${c.hlPhrase}</span>${c.h1.slice(hlIx+c.hlPhrase.length)}`
    : c.h1;
  // Pentagon geometry helpers (evaluated inline into the SVG string)
  const V = [[252.70,61.64],[402.29,170.32],[345.16,346.20],[160.24,346.20],[103.11,170.32]];
  const midR = [[252.70,96.25],[369.38,181.03],[324.83,318.16],[180.57,318.16],[136.02,181.03]];
  const innR = [[252.70,132.42],[335.00,192.20],[303.58,288.92],[201.82,288.92],[170.40,192.20]];
  const poly = pts => pts.map(p=>p.join(',')).join(' ');
  const octoPts = '-2.5,-6 2.5,-6 6,-2.5 6,2.5 2.5,6 -2.5,6 -6,2.5 -6,-2.5'; // 12×12 flat-top octagon
  const tickEnds = [[252.70,46.64],[416.56,165.68],[353.98,358.34],[151.42,358.34],[88.84,165.68]];
  const pentagonSVG = `<svg class="penta-svg" viewBox="0 0 505.22 402.32" aria-hidden="true">
      <polygon class="penta-echo penta-echo-inner" points="${poly(innR)}" fill="none" stroke="var(--latte)" stroke-width="1"/>
      <polygon class="penta-echo penta-echo-mid" points="${poly(midR)}" fill="none" stroke="var(--almond)" stroke-width="1"/>
      <polygon class="penta-outer" points="${poly(V)}" fill="none" stroke="var(--espresso)" stroke-width="1.6" stroke-linejoin="miter"/>
      ${V.map((v,i)=>`<line class="penta-tick penta-tick-${i+1}" x1="${v[0]}" y1="${v[1]}" x2="${tickEnds[i][0]}" y2="${tickEnds[i][1]}" stroke="var(--espresso)" stroke-width="1.2" stroke-linecap="round"/>`).join('')}
      <line class="penta-spark-line" x1="${V[0][0]}" y1="${V[0][1]}" x2="${V[1][0]}" y2="${V[1][1]}" stroke="var(--spark)" stroke-width="2.4" stroke-linecap="round"/>
      ${V.map((v,i)=>`<g transform="translate(${v[0]} ${v[1]})"><polygon class="penta-tp penta-tp-${i+1}" points="${octoPts}" fill="${i===0?'var(--spark)':'var(--espresso)'}" stroke="var(--canvas)" stroke-width="1"/></g>`).join('')}
      <text class="penta-center-5" x="252.70" y="245" text-anchor="middle" font-family="Manrope,sans-serif" font-weight="800" font-size="115" fill="var(--espresso)" letter-spacing="-6.9">5<tspan fill="var(--spark)">.</tspan></text>
      <text class="penta-center-q" x="252.70" y="273" text-anchor="middle" font-family="Manrope,sans-serif" font-weight="800" font-size="8.9" fill="var(--espresso)" letter-spacing="2.3">QUESTIONS</text>
    </svg>`;
  // Vertex labels — HTML overlay positioned by Figma 383:36 exact top-left percentages
  const labels = [
    {num:'01', name:'THE PROBLEM', cls:'pl-1 start'},
    {num:'02', name:'WHAT IT LOOKS LIKE', cls:'pl-2'},
    {num:'03', name:'YOUR SIZE', cls:'pl-3'},
    {num:'04', name:'WHERE YOU ARE HEADED', cls:'pl-4'},
    {num:'05', name:'WHAT YOU HAVE ALREADY', cls:'pl-5'}
  ];
  const labelsHTML = labels.map(l => `<div class="pl ${l.cls}"><span class="plnum">${l.num}</span><span class="plrule"></span><span class="plname">${l.name}</span></div>`).join('');
  const p=vpanel(`<div class="vintro-text">
      <div class="vpills">${c.pills.map((x,i)=>`<span class="vpill ${pillMods[i]}">${icons[i]||''}${x}</span>`).join('')}</div>
      <h1>${h1HTML}</h1>
      <p class="lead">${c.lead}</p>
      <div class="vbtnwrap"><button class="vbtn pri mini" id="vbegin"><span class="ctaLabel">${c.cta}</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button></div>
    </div>
    <div class="vintro-graphic">${pentagonSVG}${labelsHTML}</div>`);
  p.classList.add('vpanel--intro');
  p.querySelector('#vbegin').onclick=()=>{vstep=1;vStep();};
}
function vStep(){
  // v17.1 · Design 2 · question layout rework 2026-08-12:
  //   1. Back button UP (top of panel, .q-nav) — antes vivía en el vfoot bottom.
  //   2. Instrucción por pregunta debajo del título (.q-instruction) — antes era hint bottom, poco visible.
  //   3. Título en 1 línea siempre (.q white-space:nowrap CSS).
  //   4. No .vfoot al bottom.
  const qHead = (step,name) => `<div class="q-nav"><button class="vback" type="button">Back</button></div>
    <p class="veyebrow">Question ${step} of 5 <span class="stepname">· ${name}</span></p>`;
  const qInstr = (text) => `<p class="q-instruction">${text}</p>`;
  if(vstep===1){
    setProgress(0);
    const p=vpanel(`${qHead(1,'The problem')}
      <p class="q">What is the biggest problem right now?</p>
      ${qInstr('Pick the answer that best applies')}
      ${voptsHTML(CONFIG.symptoms)}`);
    vwire(p,CONFIG.symptoms,o=>{vstate.cat=o[1];vstate.trigger=null;vstep=2;vStep();});
    vback(p,()=>{vstep=0;vIntro();});
  } else if(vstep===2){
    setProgress(1);
    const qs=CONFIG.categories[vstate.cat].qs;
    const p=vpanel(`${qHead(2,'What it looks like')}
      <p class="q">Which of these sounds most like you?</p>
      ${qInstr('Choose the option that best describes you')}
      ${voptsHTML(qs)}`);
    vwire(p,qs,o=>{vstate.trigger=o[1];vstep=3;vStep();});
    vback(p,()=>{vstep=1;vStep();});
  } else if(vstep===3){
    setProgress(2);
    const p=vpanel(`${qHead(3,'Your size')}
      <p class="q">What is your annual revenue?</p>
      ${qInstr('Pick the range that best applies')}
      ${voptsHTML(CONFIG.size)}`);
    vwire(p,CONFIG.size,o=>{vstate.size=o[1];vstep=4;vStep();});
    vback(p,()=>{vstep=2;vStep();});
  } else if(vstep===4){
    setProgress(3);
    const p=vpanel(`${qHead(4,'Where you are headed')}
      <p class="q">What does the next year look like?</p>
      ${qInstr('Choose the option that best describes you')}
      ${voptsHTML(CONFIG.intent)}`);
    vwire(p,CONFIG.intent,o=>{vstate.intent=o[1];vstep=5;vStep();});
    vback(p,()=>{vstep=3;vStep();});
  } else if(vstep===5){
    setProgress(4);
    const p=vpanel(`${qHead(5,'What you have already')}
      <p class="q">How much of this is written down?</p>
      ${qInstr('Pick the answer that best applies')}
      ${voptsHTML(CONFIG.maturity)}`);
    vwire(p,CONFIG.maturity,o=>{vstate.maturity=o[1];setProgress(5);vDiagnose();});
    vback(p,()=>{vstep=4;vStep();});
  }
}
/* ---------- working animation ---------- */
function vDiagnose(){
  const p=vpanel(`<div class="vdiag">
    <svg class="penta penta-big" id="pentaBig" viewBox="0 0 100 100" aria-hidden="true"></svg>
    <div class="vdiagtext" id="vdt">Reading your answers</div>
    <div class="vdiagsub">Working out which of our products fit</div></div>`);
  const big=p.querySelector('#pentaBig');buildPenta(big,40,false);
  big.querySelectorAll('line').forEach((l,i)=>setTimeout(()=>l.classList.add('pulse'),i*90));
  const msgs=['Reading your answers','Finding the ones that fit','Working out how far to go'];
  let i=0;const dt=p.querySelector('#vdt');
  const total=RM?400:2200;
  const iv=setInterval(()=>{i=(i+1)%msgs.length;dt.textContent=msgs[i];},RM?150:640);
  setTimeout(()=>{clearInterval(iv);vResults(vRecommend());},total);
}
/* ---------- the recommender ----------
   Axis one: the problem and what it looks like choose the category and the hero.
   Axis two: revenue sets a depth ceiling and a money ceiling. The next year can
   lift the depth by one, never past the cap for that revenue band, and never past
   the money ceiling. What is written down already decides whether the diagnosis
   leads. Always three routes. */
function depthFor(id, maxDepth, moneyCap){
  const p=CONFIG.catalogue[id].p;
  for(let d=maxDepth; d>0; d--){ if(p[d]<=moneyCap) return d; }
  return 0;
}
function vRecommend(){
  const L=CONFIG.categories[vstate.cat];
  const trig=L.triggers[vstate.trigger]||L.triggers._default;
  let ceil=CONFIG.sizeCeiling[vstate.size];
  const cap=CONFIG.sizeCap[vstate.size];
  const money=CONFIG.moneyCap[vstate.size];
  const lifted=CONFIG.intentLift.includes(vstate.intent) && ceil<cap;
  if(lifted)ceil=ceil+1;
  let items=[trig.hero,...trig.supports];
  const mature=vstate.maturity==='mature';
  const bare=vstate.maturity==='none';
  if(bare && items.includes(L.diagnostic) && items[0]!==L.diagnostic){
    items=[L.diagnostic,...items.filter(id=>id!==L.diagnostic)];
  }
  const heroId=items[0];
  const supportCeil=mature ? Math.min(ceil,1) : 0;
  const depths={}; let moneyBit=false;
  items.forEach((id,i)=>{
    const want=i===0?ceil:supportCeil;
    const got=depthFor(id,want,money);
    if(got<want)moneyBit=true;
    depths[id]=got;
  });
  return {cat:L.name, items, hero:heroId, depths, ceil, lifted, cap, money, moneyBit,
          ctaMode: depths[heroId]>=2 ? 'call' : 'self'};
}
function vWhy(rec){
  // v17.1 · Design 2 · vwhy shorter · 2 oraciones directas · era 4-5 oraciones densas con toda la lógica
  const sizeTxt={u1m:'Under $1M',u5m:'$1M–$5M',u20m:'$5M–$20M',o20m:'Over $20M'}[vstate.size];
  const maxShown=Math.max(...rec.items.map(id=>rec.depths[id]));
  const depthTxt=CONFIG.depths[maxShown].name.toLowerCase();
  let s=`${sizeTxt} revenue, so we picked 3 at ${depthTxt} depth.`;
  if(vstate.maturity==='mature') s+=' You have the groundwork written down, so we skipped straight to what we build.';
  else if(vstate.maturity==='none') s+=' Nothing is written down yet, so we start there.';
  else if(rec.lifted) s+=' We moved one step deeper because of where you are headed.';
  else if(rec.moneyBit) s+=' One of these can go deeper once the first step proves it is worth it.';
  return s;
}
function vGate(p){
  const email=p.querySelector('#vemail').value.trim();
  const ok=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const consent=p.querySelector('#vconsent').checked;
  if(!ok||!consent){p.querySelector('#verr').classList.add('show');return null;}
  p.querySelector('#verr').classList.remove('show');vstate.email=email;return email;
}
function vCard(id,rec,locked){
  // v17.1 · Design 2 · single-card blur pattern · el `locked` sólo aplica a la 3ra card (no todas)
  // Estructura: .vcard > .vcard-inner (contenido normal, se blurrea si locked) + .vcard-lock (overlay con icon + copy, sharp)
  const it=CONFIG.catalogue[id];
  const di=rec.depths[id];
  const d=CONFIG.depths[di];
  const isHero=id===rec.hero;
  const price='$'+it.p[di].toLocaleString('en-US');
  const inner=`<div class="vcard-inner">
    ${isHero?'<span class="vherotag">Start here</span>':''}
    <div class="vtop"><h3>${it.name}</h3><span class="vband">${d.name}</span></div>
    <p>${it.demo}</p>
    <div class="vfootline"><span class="vprice">${price}</span><span class="vref">${it.ref}</span></div>
    <p class="vwhat">${d.what}</p>
    ${VHANDLES[it.ref]?`<a class="vprod" href="${VSTORE}/products/${VHANDLES[it.ref]}" target="_blank" rel="noopener">View the product<span aria-hidden="true"> ↗</span></a>`:''}
  </div>`;
  const lock=locked?`<div class="vcard-lock" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="10.5" width="14" height="10" rx="1.5"/><path d="M8 10.5V7a4 4 0 018 0v3.5"/></svg>
    <span>Enter your email above to unlock</span>
  </div>`:'';
  return `<div class="vcard${isHero?' vhero':''}${locked?' locked-single':''}">${inner}${lock}</div>`;
}
function vResults(rec){
  /* v17.1 · Design 2 · Frame 397:2 iteración 2026-08-12 · resultados simplificados:
     - Removed: vfloor eyebrow, vcards con 3 cards + preview, vtotal price summary.
     - Added: triangle graphic hero (echoing pentagon del intro pero con 3 sides = 3 things) con big "3." + "THINGS" en Spark al centro.
     - h1 pattern: "We found 3 things we would do about it." con "3 things" en Spark ExtraBold, rest en Bold.
     - vwhy: shorter (2 sentences en lugar de 4-5) via vWhy() refactor.
     - vgate copy nueva: h3 "See it in more detail", consent line rewrite, mismo email input + CTAs.
     - Bottom actions row: Re-try the questionnaire + Delete results (rojo status/error). */
  // Triangle geometry · viewBox 320×320 · point-up equilateral · centered at (160,160)
  const cx=160, cy=160, R_outer=130, R_mid=R_outer*0.75, R_inner=R_outer*0.48;
  const triVerts=(r)=>{const out=[];for(let i=0;i<3;i++){const a=(-90+i*120)*Math.PI/180;out.push([cx+r*Math.cos(a),cy+r*Math.sin(a)]);}return out;};
  const V=triVerts(R_outer);
  const midV=triVerts(R_mid);
  const innV=triVerts(R_inner);
  const poly=pts=>pts.map(p=>p.join(',')).join(' ');
  const octoPts='-2.5,-6 2.5,-6 6,-2.5 6,2.5 2.5,6 -2.5,6 -6,2.5 -6,-2.5';
  const triangleSVG=`<svg class="tri-svg" viewBox="0 0 320 320" aria-hidden="true">
    <polygon class="tri-echo tri-echo-inner" points="${poly(innV)}" fill="none" stroke="var(--latte)" stroke-width="1"/>
    <polygon class="tri-echo tri-echo-mid" points="${poly(midV)}" fill="none" stroke="var(--almond)" stroke-width="1"/>
    <polygon class="tri-outer" points="${poly(V)}" fill="none" stroke="var(--espresso)" stroke-width="1.6" stroke-linejoin="miter"/>
    ${V.map(v=>`<g transform="translate(${v[0]} ${v[1]})"><polygon class="tri-tp" points="${octoPts}" fill="var(--espresso)" stroke="var(--canvas)" stroke-width="1"/></g>`).join('')}
    <text class="tri-center-num" x="160" y="205" text-anchor="middle" font-family="Manrope,sans-serif" font-weight="800" font-size="115" fill="var(--espresso)" letter-spacing="-6.9">3<tspan fill="var(--spark)">.</tspan></text>
    <text class="tri-center-lbl" x="160" y="238" text-anchor="middle" font-family="Manrope,sans-serif" font-weight="800" font-size="9" fill="var(--spark)" letter-spacing="2.3">THINGS</text>
  </svg>`;
  const cta=(id,cls,label)=>`<button class="vbtn ${cls}" id="${id}"><span class="ctaLabel">${label}</span><span class="ctaBadge"><span class="ctaArrow"><svg class="a1" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg><svg class="a2" viewBox="0 0 15 12" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 6h12M9 2l4 4-4 4"/></svg></span></span></button>`;
  const ctaBlock=rec.ctaMode==='call'
    ? `${cta('vbook','pri','Book a call and unlock')}<div class="vor"><span>or</span></div>${cta('vsend','line','Email me my results')}`
    : `${cta('vsend','pri','Email me my results')}<div class="vor"><span>or</span></div>${cta('vbook','line','Book a call instead')}`;
  const p=vpanel(`
    <div class="results-hero">
      <div class="results-hero-viz">${triangleSVG}</div>
      <h1 class="results-h1">We found <span class="hl">3 things</span> we would do about it.</h1>
    </div>
    <p class="vwhy">${vWhy(rec)}</p>
    <div class="vgate">
      <h3>See it in more detail</h3>
      <p>Enter your email to see the 3 things in detail and get the full report. ${rec.ctaMode==='call'?'At your size it is worth a call first, so we can ask a few things back.':''}</p>
      <input class="field" id="vemail" type="email" inputmode="email" placeholder="you@company.com" autocomplete="email" autofocus>
      <div class="verr" id="verr">Put in a real email and tick the box to carry on.</div>
      <label class="vconsent"><input type="checkbox" id="vconsent"><span class="vcheckbox" aria-hidden="true"><svg viewBox="0 0 12 10"><path d="M1 5.2l3.4 3.4L11 1.6"/></svg></span><span>Send me the results and occasional useful notes. I can unsubscribe any time.</span></label>
      ${ctaBlock}
    </div>
    <div class="results-actions">
      <button class="results-action" id="vretry" type="button">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 10a6 6 0 1 1 3 5.19"/><path d="M4 5v5h5"/></svg>
        Re-try the questionnaire
      </button>
      <button class="results-action danger" id="vdelete" type="button">
        <svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 5l10 10M15 5l-10 10"/></svg>
        Delete results
      </button>
    </div>`);
  setProgress(5);
  p.querySelector('#vsend').onclick=()=>{
    const email=vGate(p);if(!email)return;
    /* SELF-SERVE HOOK: POST { email, ...vstate, items:rec.items, depths:rec.depths } to the
       email platform and trigger the results flow. Build the delivered content server-side. */
    vPreparing(email,rec);
  };
  p.querySelector('#vbook').onclick=()=>{
    const email=vGate(p);if(!email)return;
    /* REQUEST-A-CALL HOOK: POST { email, ...vstate, items:rec.items, depths:rec.depths,
       intent:'call' } to the team lead endpoint AND subscribe the email. */
    vCall(email,rec);
  };
  p.querySelector('#vretry').onclick=vReset;
  p.querySelector('#vdelete').onclick=vReset;
}
function vUnlock(p,then){
  // v17.1 · sólo la 3ra card tiene .locked-single (blur+overlay) · unlock la remueve
  p.querySelectorAll('.vcard.locked-single').forEach(c=>c.classList.remove('locked-single'));
  setTimeout(then,RM?200:900);
}
function vPreparing(email,rec){
  const p=vpanel(`<div class="vdiag">
    <svg class="penta penta-big" id="pentaBig2" viewBox="0 0 100 100" aria-hidden="true"></svg>
    <div class="vdiagtext" id="vdt2">Writing it up</div>
    <div class="vdiagsub">A few seconds</div></div>`);
  const big=p.querySelector('#pentaBig2');buildPenta(big,40,false);
  big.querySelectorAll('line').forEach((l,i)=>setTimeout(()=>l.classList.add('pulse'),i*90));
  const msgs=['Writing it up','Explaining each one','Sending it over'];
  let i=0;const dt=p.querySelector('#vdt2');
  const total=RM?400:1900;
  const iv=setInterval(()=>{i=(i+1)%msgs.length;dt.textContent=msgs[i];},RM?150:620);
  setTimeout(()=>{clearInterval(iv);vSent(email,rec);},total);
}
function vSent(email,rec){
  // v0.63 · results ya viajaron por email — dejamos sólo el banner de confirmación + eyebrow de categoría + Start again
  const p=vpanel(`
    <div class="vbanner"><span class="vcheck small"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#FAF5EC" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
      <div><b>Sent to ${email}.</b> It should land in a few minutes.</div></div>
    <p class="vfloor" style="margin-top:20px;">Your results · ${rec.cat}</p>
    <button class="vrestart" id="vagain">Start again</button>`);
  setProgress(5);p.querySelector('#vagain').onclick=vReset;
}
function vCall(email,rec){
  const cards=rec.items.map(id=>vCard(id,rec,false)).join('');
  const p=vpanel(`
    <div class="vbanner"><span class="vcheck small"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="16" rx="1" stroke="#FAF5EC" stroke-width="2.5"/><path d="M3 10h18M8 3v4M16 3v4" stroke="#FAF5EC" stroke-width="2.5" stroke-linecap="round"/></svg></span>
      <div><b>We will be in touch at ${email}</b> to find a time. We have your answers, so the call starts with your situation.</div></div>
    <p class="vfloor" style="margin-top:20px;">Your results · ${rec.cat}</p>
    <h1 style="font-size:26px; margin:6px 0 16px;">Here they are.</h1>
    <div class="vcards">${cards}</div>
    <button class="vrestart" id="vagain">Start again</button>`);
  setProgress(5);p.querySelector('#vagain').onclick=vReset;
}
function vReset(){Object.keys(vstate).forEach(k=>vstate[k]=null);vstep=0;vIntro();}
vIntro();

/* ===================== /BOOK · v15.2 =====================
   Cold-path booking, form nativo con slots flexibles + CTA disabled hasta validation.
   Cambios v15.2 sobre v15.1:
   · Reordenado: tz primero (arriba), luego slots (abajo). Antes tz estaba en col 2 del
     row 2, ahora tz es el primer field de .bwhen full-width.
   · Preferred date & time: cada slot es un pair {date, time} en una sola línea (date input
     + time input side-by-side). Antes había 1 lista de dates y un rango horario global; ahora
     cada slot es una propuesta específica (date + time exacto). Multi (hasta 3 slots), primer
     row required, extras removibles con ×.
   · Validation: nameOk, emailOk, situationOk, tzOk + al menos 1 slot completo (date+time
     ambos filled). Los slots extras si están agregados también requieren ambos filled para
     no quedar como slots incompletos en el submit — o se completan o se remueven.
   · Confirm copy: lista los N slots como "DD/MM/YYYY at HH:MM" (dropped el "between from-to"
     que no aplica más).
   Sin backend: POST { name, email, company, situation, slots: [{date, time}], tz }. Human
   signs dentro de one business day. */
(function(){
  const stage=document.getElementById('bookstage');
  const form=document.getElementById('bform');
  if(!stage||!form)return;
  const initial=document.getElementById('bpanel-form');
  const MAX_DATES=3;
  /* v0.69 · auto-detect timezone del user via Intl API · si matchea una option la seleccionamos, si no insertamos la del user al top de la lista */
  (function detectTz(){
    const tz=form.querySelector('select[name="tz"]');
    if(!tz)return;
    let userTz='';
    try{userTz=Intl.DateTimeFormat().resolvedOptions().timeZone;}catch(e){}
    if(!userTz)return;
    const opts=[...tz.options];
    const match=opts.find(o=>o.value===userTz);
    if(match){match.selected=true;}
    else{
      const newOpt=new Option(userTz,userTz,true,true);
      tz.insertBefore(newOpt,tz.options[1]||null);
    }
  })();
  function fmtDate(iso){
    if(!iso)return'';
    const [y,m,d]=iso.split('-');
    return `${d}/${m}/${y}`;
  }
  /* v15.2 · collect all filled slots (date+time pairs) from the .bdate-row list.
     Retorna array de {date, time} SOLO para rows donde ambos values están filled.
     Sort ascendente por date+time combo. Dedup por combo (mismo date+time contado 1 vez). */
  function collectSlots(){
    const rows=[...form.querySelectorAll('#bdates .bdate-row')];
    const pairs=rows.map(r=>{
      const d=r.querySelector('input[name="date"]').value;
      const t=r.querySelector('input[name="time"]').value;
      return {date:d, time:t};
    }).filter(p=>p.date.length>0 && p.time.length>0);
    /* dedup por date+time combo */
    const seen=new Set();
    const dedup=[];
    pairs.forEach(p=>{
      const k=p.date+'T'+p.time;
      if(!seen.has(k)){seen.add(k); dedup.push(p);}
    });
    dedup.sort((a,b)=>(a.date+a.time).localeCompare(b.date+b.time));
    return dedup;
  }
  /* v15.2 · validate: name+email+situation+tz + ≥1 slot completo + todos los slots agregados
     tienen ambos date+time (evita slots huérfanos que quedaron a medio llenar) */
  function validate(){
    const data=Object.fromEntries(new FormData(form).entries());
    const emailOk=/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((data.email||'').trim());
    const nameOk=(data.name||'').trim().length>0;
    const situationOk=(data.situation||'').trim().length>0;
    const tzOk=(data.tz||'').length>0;
    /* check todos los slot rows presentes: cada row must tener ambos date+time filled o vacíos ambos (0-value = huérfano) */
    const rows=[...form.querySelectorAll('#bdates .bdate-row')];
    const rowsComplete=rows.every(r=>{
      const d=r.querySelector('input[name="date"]').value;
      const t=r.querySelector('input[name="time"]').value;
      return d.length>0 && t.length>0;
    });
    const slots=collectSlots();
    const slotsOk=rowsComplete && slots.length>=1;
    return emailOk && nameOk && situationOk && tzOk && slotsOk;
  }
  /* v15.1 · toggle disabled state del CTA + limpia el error inline al primer touch */
  function refresh(){
    const btn=form.querySelector('#bbook');
    const err=document.getElementById('berr');
    const ok=validate();
    if(btn){
      btn.disabled=!ok;
      btn.setAttribute('aria-disabled', ok?'false':'true');
    }
    if(err && ok) err.classList.remove('show');
    /* también sync el remove buttons según cuántas date-rows haya */
    syncDateAdd();
  }
  /* v15.3 · slot-add/remove: cap at MAX_DATES (3 slots max). Primer row siempre required
     (no tiene ×). Cada row extra: date input + time input + botón × remove (Figma Atom ·
     Button · Icon-Only · type=Exit · 44px circle rosa con SVG cross adentro). */
  function addDate(){
    const list=document.getElementById('bdates');
    if(!list)return;
    const rows=list.querySelectorAll('.bdate-row');
    if(rows.length>=MAX_DATES)return;
    const idx=rows.length;
    const row=document.createElement('div');
    row.className='bdate-row';
    row.innerHTML=`
      <input class="field bdate-input" type="date" name="date" aria-label="Preferred date ${idx+1}">
      <input class="field btime-input" type="time" name="time" aria-label="Preferred time ${idx+1}">
      <button type="button" class="bdrem" aria-label="Remove this slot"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8"/></svg></button>`;
    list.appendChild(row);
    /* No hookeamos input event por row — el form-level listener captura por bubble. Solo el remove necesita handler. */
    row.querySelector('.bdrem').addEventListener('click',()=>{
      row.remove();
      refresh();
    });
    refresh();
  }
  /* v15.3 · sync visibility del Add button: al llegar al max, el botón desaparece
     del layout entero (hidden attribute → display:none) en vez de quedar visible-disabled.
     Design 2: "la palabra queda confusa cuando ya no se puede clickear". */
  function syncDateAdd(){
    const btn=document.getElementById('badd');
    if(!btn)return;
    const rows=document.querySelectorAll('#bdates .bdate-row');
    btn.hidden=rows.length>=MAX_DATES;
  }
  function reset(){
    stage.innerHTML='';
    stage.appendChild(initial);
    form.reset();
    /* rebuild slots list a estado inicial (1 sola row required, date + time) */
    const list=document.getElementById('bdates');
    if(list){
      list.innerHTML=`<div class="bdate-row">
        <input class="field bdate-input" type="date" name="date" required aria-label="Preferred date 1">
        <input class="field btime-input" type="time" name="time" required aria-label="Preferred time 1">
      </div>`;
    }
    document.getElementById('berr').classList.remove('show');
    wireForm();
    refresh();
  }
  function submit(e){
    e.preventDefault();
    const err=document.getElementById('berr');
    if(!validate()){err.classList.add('show');return;}
    err.classList.remove('show');
    const data=Object.fromEntries(new FormData(form).entries());
    const slots=collectSlots();
    /* HOOK: POST data al booking endpoint acá. No backend por ahora. */
    /* Data shape: { name, email, company, situation, slots: [{date: YYYY-MM-DD, time: HH:MM}], tz (IANA) } */
    confirm(data.email,slots,data.tz);
  }
  function confirm(email,slots,tz){
    const slotList=slots.length?slots.map(s=>`<li><b>${fmtDate(s.date)}</b> at <b>${s.time}</b></li>`).join(''):'';
    const tzLine=tz?`<p class="bslots-range">Times in <b>${tz}</b></p>`:'';
    stage.innerHTML=`
      <div class="bpanel bconfirm">
        <div class="vbanner"><span class="vcheck small"><svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#FAF5EC" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          <div><b>Sent to ${email}.</b> We reply within one business day to lock one of the slots you proposed, or offer alternatives.</div></div>
        <div class="bslots">
          <p class="bslots-lab">Your options</p>
          <ul class="bslots-list">${slotList}</ul>
          ${tzLine}
        </div>
        <button class="brestart" id="bagain">Book another call</button>
      </div>`;
    stage.querySelector('#bagain').onclick=reset;
    /* scroll suave al head del shell · si el user clickeo desde el bottom del form no pierde el banner */
    const shell=document.querySelector('.bookshell');
    if(shell) shell.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth', block:'start'});
  }
  /* v15.1 · wire todos los input events del form (input+change para inputs/selects/textarea) al refresh, y el submit al submit handler. Idempotente vía data-wired flag para poder llamar de nuevo post reset(). */
  function wireForm(){
    if(form.dataset.wired==='1')return;
    form.dataset.wired='1';
    form.addEventListener('input',refresh);
    form.addEventListener('change',refresh);
    form.addEventListener('submit',submit);
    const addBtn=document.getElementById('badd');
    if(addBtn) addBtn.addEventListener('click',addDate);
  }
  wireForm();
  refresh();
})();

/* ===================== /NEWS · v5 =====================
   Filter bar handling · search query + kind text-link row.
   Matching combines query (title + summary + kind, case-insensitive) AND kind
   (all | evidence | method | practice). Cuando el user filtra por kind ≠ all
   O escribe algo en el search, el grid se pone en modo .filtered: la jerarquía
   big/mid colapsa uniforme y la ngrid-divider se oculta.
   Cards no matcheantes reciben .hidden. Si el matched count queda en 0, el
   grid entra en .empty y se muestra la nempty note. */
(function(){
  const grid=document.getElementById('ngrid');
  const query=document.getElementById('nquery');
  const kinds=document.querySelectorAll('#page-news .nkind-link');
  if(!grid||!query||!kinds.length)return;
  let activeKind='all';
  function apply(){
    const q=query.value.trim().toLowerCase();
    const filterOn=(activeKind!=='all')||q.length>0;
    grid.classList.toggle('filtered',filterOn);
    let visible=0;
    grid.querySelectorAll('.ncard').forEach(card=>{
      const kind=card.dataset.kind||'';
      const title=(card.querySelector('h2')||{}).textContent||'';
      const summary=(card.querySelector('.nsummary')||{}).textContent||'';
      const eyebrow=(card.querySelector('.neyebrow')||{}).textContent||'';
      const hay=(title+' '+summary+' '+eyebrow).toLowerCase();
      const matchKind=(activeKind==='all')||kind===activeKind;
      const matchQuery=q.length===0||hay.indexOf(q)!==-1;
      const show=matchKind&&matchQuery;
      card.classList.toggle('hidden',!show);
      if(show)visible++;
    });
    grid.classList.toggle('empty',visible===0);
  }
  kinds.forEach(btn=>{
    btn.addEventListener('click',()=>{
      activeKind=btn.dataset.kind||'all';
      kinds.forEach(b=>{
        const on=b===btn;
        b.classList.toggle('active',on);
        b.setAttribute('aria-selected',on?'true':'false');
      });
      apply();
    });
  });
  query.addEventListener('input',apply);
})();


/* ---------- the eight-stage cycle drawn on the octagon ---------- */
/* v6.2 · cycle rewritten as one continuous octagon path that draws in on scroll.
   Replaces the 8-independent-lines approach (which overlapped at vertices).
   Uses stroke-dasharray + stroke-dashoffset for a clean one-pen tracing. */
(function(){
  const STAGES=['See','Define','Encode','Act','Test','Correct','Retain','Revisit'];
  /* v15.8 · icon SVG paths per stage (line-style, viewBox 14×14, stroke currentColor 1.4px).
     Semántica: See→eye, Define→pencil, Encode→brackets, Act→forward arrow, Test→check,
     Correct→refresh curve, Retain→folder, Revisit→clock. */
  const ICONS=[
    '<path d="M1.5 7c1.5-3 3.5-4.5 5.5-4.5s4 1.5 5.5 4.5c-1.5 3-3.5 4.5-5.5 4.5s-4-1.5-5.5-4.5z"/><circle cx="7" cy="7" r="2"/>',
    '<path d="M2 12l1-3.5L9.5 2l2.5 2.5L5.5 11 2 12z"/>',
    '<path d="M4.5 3L1.5 7l3 4M9.5 3l3 4-3 4"/>',
    '<path d="M2 7h9M8 3.5l3.5 3.5-3.5 3.5"/>',
    '<path d="M2 7.5l3 3 7-7"/>',
    '<path d="M12 7a5 5 0 1 1-1.5-3.5M11 1v3.5h-3.5"/>',
    '<rect x="1.5" y="4" width="11" height="8" rx=".8"/><path d="M4 4V2.5h4V4"/>',
    '<circle cx="7" cy="7" r="5"/><path d="M7 4v3.2l2 1.3"/>'
  ];
  const svg=document.getElementById('cycleocto');
  if(!svg)return;
  const base=document.getElementById('cyclebase'), path=document.getElementById('cyclepath'), T=document.getElementById('cyclelabels');
  const cx=210, cy=210, r=140, lr=176;
  function vert(i){const a=(-90+22.5+i*45)*Math.PI/180; return [cx+r*Math.cos(a), cy+r*Math.sin(a)];}
  /* build the closed octagon path once — used by both the idle base and the drawn active path */
  const pts=[]; for(let i=0;i<8;i++) pts.push(vert(i));
  const d='M'+pts[0][0].toFixed(1)+','+pts[0][1].toFixed(1)+
          pts.slice(1).map(p=>'L'+p[0].toFixed(1)+','+p[1].toFixed(1)).join('')+'Z';
  base.setAttribute('d', d); path.setAttribute('d', d);
  /* perimeter for dashoffset animation */
  const P=path.getTotalLength();
  path.style.strokeDasharray=P; path.style.strokeDashoffset=P;
  /* v15.8 · labels: wrap icon + text en un <g data-i> por stage. Positioning per anchor:
     middle (top/bottom) → icon centered above text · start (right) → icon left of text · end (left) → icon right of text.
     El .lit se togglea en el <g> parent (antes se togglea en el <text> directamente). */
  let labels='';
  for(let i=0;i<8;i++){
    const a=pts[i], b=pts[(i+1)%8];
    const mid=[(a[0]+b[0])/2,(a[1]+b[1])/2];
    const ang=Math.atan2(mid[1]-cy, mid[0]-cx);
    const lx=cx+lr*Math.cos(ang), ly=cy+lr*Math.sin(ang);
    let anchor='middle';
    if(lx>cx+30)anchor='start'; else if(lx<cx-30)anchor='end';
    /* v15.9 · vertical/horizontal spacing balanced. Measured con Playwright: iconY=ly-24 dio
       7-9px visual gap vs 10-11px horizontal. Bump a ly-26 para que ambos midan ~10px matching. */
    let iconX, iconY, textX, textY;
    if(anchor==='middle'){
      iconX=lx-7; iconY=ly-26;
      textX=lx; textY=ly+4;
    } else if(anchor==='start'){
      iconX=lx; iconY=ly-7;
      textX=lx+20; textY=ly+4;
    } else {
      iconX=lx-14; iconY=ly-7;
      textX=lx-20; textY=ly+4;
    }
    labels+=`<g data-i="${i}"><g class="stage-ic" transform="translate(${iconX.toFixed(1)},${iconY.toFixed(1)})">${ICONS[i]}</g><text x="${textX.toFixed(1)}" y="${textY.toFixed(1)}" text-anchor="${anchor}">${STAGES[i]}</text></g>`;
  }
  T.innerHTML=labels;
  const core=svg.querySelector('.cyclecore');
  const groups=[...T.querySelectorAll('g[data-i]')];
  /* the scroll drive calls this: p in [0,1] uncovers the path and lights labels progressively.
     v6.3 · when p>=0.98 the SVG gains .resolved, triggering the CSS transformation
     from cycle → isotype-as-hero (see #cycleocto.resolved styles above).
     v15.8 · lit togglea en el <g data-i> parent (no en el <text> directo) para pintar
     text + icon en Espresso al mismo tiempo. */
  window.cycleSet=function(p){
    p=Math.max(0, Math.min(1, p));
    path.style.strokeDashoffset=(P*(1-p)).toFixed(2);
    const lit=Math.min(8, Math.floor(p*8.6));
    groups.forEach((g,i)=>g.classList.toggle('lit', i<lit));
    core.classList.toggle('on', p>0.92);
    svg.classList.toggle('resolved', p>=0.98);
  };
  window.cycleSet(0);
})();

/* v16.10 · Animation trigger via IntersectionObserver + MutationObserver.
   v16.11 · LOOP fix: cuando user va y viene entre slide 0 y slide 1 del carousel
   pineado, la animación se re-triggerea. Approach:
   1. IntersectionObserver marca el elemento como "seen" (visto al menos una vez)
      cuando está >35% en viewport. Esto evita el fire prematuro on page load
      off-screen.
   2. MutationObserver watch-ea el excard parent .on class. Cuando .on se agrega y
      el elemento ya está "seen" O es actualmente visible (bounding rect en viewport),
      re-trigger la animación (remove .play + reflow + add .play).
      Cuando .on se remueve, remove .play (animation resets al estado 0%).
   3. Primera vez: IO fire → seen=true → si excard ya está .on → trigger immediate.
   Así la animation fire cada vez que el user entra a un slide, no una sola vez.
   v21.2 · Extendido a los elementos alt tablet+mobile (mp3-depths-graphic y
   mp3-timeline). Además el MO ahora chequea bounding rect además de seen: en el
   mobile carousel el user puede clickear "next" y el elemento pasa de display:none
   a visible en el mismo tick → seen sigue false pero visible es true, entonces
   triggerAnim fire. */
(function(){
  const targets = document.querySelectorAll(
    '#mp3 .fig-3depths, #mp3 .fig-timeline, #mp3 .mp3-depths-graphic, #mp3 .mp3-timeline'
  );
  if (!targets.length || !('IntersectionObserver' in window)) {
    targets.forEach(s => s.classList.add('play'));
    return;
  }

  const seen = new WeakSet();
  function triggerAnim(el){
    el.classList.remove('play');
    void el.offsetWidth; // force reflow · reinicia animation
    el.classList.add('play');
  }
  function isInViewport(el){
    const r = el.getBoundingClientRect();
    if (r.width === 0 && r.height === 0) return false;
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  const io = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting && e.intersectionRatio >= 0.35 && !seen.has(e.target)) {
        seen.add(e.target);
        // Si el excard ya está .on al momento del first sight, trigger immediate
        const excard = e.target.closest('.excard');
        if (excard && excard.classList.contains('on')) {
          triggerAnim(e.target);
        }
      }
    });
  }, { threshold: [0.35] });
  targets.forEach(t => io.observe(t));

  // MutationObserver por elemento: re-trigger animation cuando excard .on cambia
  targets.forEach(t => {
    const excard = t.closest('.excard');
    if (!excard) return;
    const mo = new MutationObserver(() => {
      if (excard.classList.contains('on')) {
        // Trigger si ya fue visto O si actualmente está en viewport (edge case
        // mobile carousel: el elemento pasó de display:none a visible en el mismo
        // tick del click "next" — IO no alcanzó a fire pero el elemento SÍ está
        // visible ahora). Marca seen para consistency.
        if (seen.has(t) || isInViewport(t)) {
          seen.add(t);
          triggerAnim(t);
        }
      } else {
        t.classList.remove('play');
      }
    });
    mo.observe(excard, { attributes: true, attributeFilter: ['class'] });
  });
})();

/* v15.10 · Six commitments · paged carousel sin scroll horizontal (feedback Figma 374:9545).
   Dot click → toggle .on en cards+promises+dots matching el data-pair.
   v16.10 · selector updated: .cvgrid.cv6 → .mc-cards (nuevo layout HTML).
   v16.11 · AUTO-ADVANCE: setInterval cicla pairs 0→1→2 cada 5s. Click manual en
   dot resetea el timer. IntersectionObserver pausa el timer cuando la sección
   no está en viewport (perf + no ciclar invisible). */
(function(){
  const section=document.getElementById('mcommit');
  const cardsWrap=document.querySelector('#mcommit .mc-cards');
  const pager=document.querySelector('#mcommit .cvpager');
  const promises=document.querySelectorAll('#mcommit .promises .prom');
  const prevBtn=document.querySelector('#mcommit .mc-prev');
  const nextBtn=document.querySelector('#mcommit .mc-next');
  if(!section||!cardsWrap||!pager) return;
  const pairs=[...cardsWrap.querySelectorAll('.mc-pair')];
  const dots=[...pager.querySelectorAll('.cvdot')];
  const N_PAIRS = pairs.length;
  const INTERVAL_MS = 5000;
  let currentPair = 0;
  let autoTimer = null;
  let inViewport = false;

  function setActivePair(pair){
    currentPair = ((pair % N_PAIRS) + N_PAIRS) % N_PAIRS; // wrap negatives too
    dots.forEach(d=>d.classList.toggle('on', +d.dataset.pair===currentPair));
    // v22.3 · desactivada la sincro carousel↔promise. Las 3 consequences ahora
    // viven en .promises.mc-static al final de la sección, visibles todas juntas.
    // La línea previa promises.forEach(...) se dejaba sin efecto en la nueva
    // estructura porque los .prom estáticos no tienen data-pair, pero se comenta
    // para clarity y para evitar warnings de "toggling class on non-target elements":
    // promises.forEach(p=>p.classList.toggle('on', +p.dataset.pair===currentPair));
    pairs.forEach(g=>g.classList.toggle('on', +g.dataset.pair===currentPair));
  }
  function startAuto(){
    /* v23.3 · Design 2 red-line: ningún carousel debe reproducirse automaticamente ·
       disabled el timer del #mcommit para consistency con el resto. Los click handlers
       de chevrons/dots siguen call-eando startAuto() pero ahora es no-op. */
    stopAuto();
    return;
  }
  function stopAuto(){
    if (autoTimer) { clearInterval(autoTimer); autoTimer = null; }
  }
  // Chevron prev/next · wrap around
  if (prevBtn) prevBtn.addEventListener('click', () => { setActivePair(currentPair - 1); startAuto(); });
  if (nextBtn) nextBtn.addEventListener('click', () => { setActivePair(currentPair + 1); startAuto(); });
  dots.forEach(d=>{
    d.addEventListener('click', () => {
      setActivePair(+d.dataset.pair);
      startAuto(); // Reset timer al click manual
    });
  });
  // Pausa el auto cuando el user hovers sobre las cards/dots/chevrons (para leer sin cambio)
  const hoverArea = section.querySelector('.mc-bottom');
  if (hoverArea) {
    hoverArea.addEventListener('mouseenter', stopAuto);
    hoverArea.addEventListener('mouseleave', () => { if (inViewport) startAuto(); });
  }
  // IntersectionObserver: start/stop auto según sección visible
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        inViewport = e.isIntersecting;
        if (inViewport) startAuto();
        else stopAuto();
      });
    }, { threshold: 0.3 });
    io.observe(section);
  } else {
    inViewport = true;
    startAuto();
  }
  setActivePair(0);
})();

// hero record cycles through representative engagements
(function(){
  const rec=document.getElementById('herorec'); if(!rec) return;
  if(!rec||RM)return;
  const title=rec.querySelector('#hrTitle'), foot=rec.querySelector('#hrFoot');
  const avs=[...rec.querySelectorAll('.arow .av')];
  const first={title:title.textContent, rows:avs.map(a=>a.innerHTML), foot:foot.textContent};
  const records=[first,
    {title:'Octaflow · outcome record',
     rows:['month-end close · 9 days to 3','extract → reconcile → sign-off','on your real cases · standard held','your team · checklist kept'],
     foot:'Outcome matched'},
    {title:'Octaflow · outcome record',
     rows:['every AI use approved, evidenced','register → rules → audit trail','decision rights stay human','your team · audit trail kept'],
     foot:'Outcome matched'}];
  let i=0;
  setInterval(()=>{
    if(!pages.home.classList.contains('active')||document.hidden)return;
    i=(i+1)%records.length;
    rec.classList.add('fading');
    setTimeout(()=>{
      const r=records[i];
      title.textContent=r.title; foot.textContent=r.foot;
      avs.forEach((a,k)=>a.innerHTML=r.rows[k]);
      rec.classList.remove('fading');
    },320);
  },7000);
})();


/* the slide fits the frame: measure whatever chrome sits above it */
(function(){
  function chrome(){
    const nav=document.querySelector('nav.site');
    let px=0;
    if(nav) px+=nav.getBoundingClientRect().height;
    document.documentElement.style.setProperty('--chrome', Math.round(px)+'px');
  }
  chrome(); addEventListener('resize', chrome); addEventListener('load', chrome);
  const sh=document.querySelector('.sitehead');
  if(sh){const t=()=>sh.classList.toggle('scrolled', scrollY>8); addEventListener('scroll', t, {passive:true}); t();}
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(chrome);
})();

/* ===== the hero object =====
   The outcome sits still at the centre. Everything we design keeps moving around it,
   and every piece feeds a pulse back into it. The one fixed point is the client's result. */
(function(){
  const svg=document.getElementById('horb'); if(!svg) return;
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CX=260, CY=260, CORE=64, RING=176;
  const octo=(cx,cy,r,rot=0)=>{let d='';for(let i=0;i<8;i++){const a=(-90+22.5+i*45)*Math.PI/180+rot;
    d+=(i?'L':'M')+(cx+r*Math.cos(a)).toFixed(2)+' '+(cy+r*Math.sin(a)).toFixed(2)+' ';}return d+'Z';};
  document.getElementById('orbCoreShape').setAttribute('d', octo(CX,CY,CORE));
  /* rings leaving the outcome, in the shape of the mark */
  document.getElementById('orbRipples').innerHTML =
    [0,1,2].map(()=>`<path class="orbrip" d="${octo(CX,CY,CORE)}" fill="none" stroke="#FF7F6B" stroke-width="2.5"/>`).join('');
  /* on a phone the ring labels are unreadable, so we drop them and crop in on the object */
  const mq=matchMedia('(max-width:1000px)');
  function fit(){ svg.setAttribute('viewBox', mq.matches ? '62 62 396 396' : '0 0 520 520'); }
  fit(); mq.addEventListener('change', fit);

  const PARTS=['the model','the agents','the rules','the evaluations','the memory','the human gate','the data','the record'];
  const geo=PARTS.map((p,i)=>{
    const a=(-90+i*45)*Math.PI/180;
    return {p, a, x:CX+RING*Math.cos(a), y:CY+RING*Math.sin(a), ux:Math.cos(a), uy:Math.sin(a)};
  });

  let links='', nodes='', pulses='';
  geo.forEach((g,i)=>{
    /* pathLength="1" normaliza el largo real de cada radio a 1, así el keyframe
       orbLine (stroke-dashoffset 1→0, v14.1) hace crecer las 8 líneas al mismo
       ritmo aunque el radio real mida distinto en px según el ángulo */
    links+=`<line class="orbl" data-i="${i}" stroke="#DECDB8" stroke-width="1.5" pathLength="1"/>`;
    pulses+=`<circle class="orbp" data-i="${i}" r="3.2" fill="#FF7F6B"/>`;
    const anchor = Math.abs(g.x-CX)<6 ? 'middle' : (g.x>CX ? 'start' : 'end');
    const lx = anchor==='start' ? g.x+18 : (anchor==='end' ? g.x-18 : g.x);
    const ly = g.y + (Math.abs(g.y-CY)<6 ? 5 : (g.y>CY ? 26 : -19));
    nodes+=`<g class="orbn" data-i="${i}">
      <path class="orbnp" d="" fill="#F2EAD9" stroke="#5F4234" stroke-width="2"/>
      <text class="orbnt" x="${lx.toFixed(1)}" y="${ly.toFixed(1)}" font-size="12.5" font-weight="500" fill="#5F4234" text-anchor="${anchor}">${g.p}</text>
    </g>`;
  });
  document.getElementById('orbLinks').innerHTML=links;
  document.getElementById('orbPulses').innerHTML=pulses;
  document.getElementById('orbNodes').innerHTML=nodes;

  const lineEls=[...svg.querySelectorAll('.orbl')], pulseEls=[...svg.querySelectorAll('.orbp')],
        nodeEls=[...svg.querySelectorAll('.orbn')], nodePaths=[...svg.querySelectorAll('.orbnp')];

  function place(i, off){
    const g=geo[i];
    const x=g.x+g.ux*off, y=g.y+g.uy*off;
    nodePaths[i].setAttribute('d', octo(x, y, 11, off*0.05));
    const ix=CX+(CORE+7)*g.ux, iy=CY+(CORE+7)*g.uy;
    const ox=x-g.ux*13, oy=y-g.uy*13;
    lineEls[i].setAttribute('x1',ix.toFixed(1)); lineEls[i].setAttribute('y1',iy.toFixed(1));
    lineEls[i].setAttribute('x2',ox.toFixed(1)); lineEls[i].setAttribute('y2',oy.toFixed(1));
    return {ix,iy,ox,oy};
  }
  geo.forEach((g,i)=>place(i,0));

  if(RMq){ nodeEls.forEach(n=>n.style.opacity=1); lineEls.forEach(l=>l.style.opacity=1); return; }

  /* v14.1 · acto 1, construcción (feedback Design 2 · "que se construya el
     círculo de octógonos y luego empieza a parpadear"): cada línea empieza a
     "crecer" hacia afuera (pathLength trick, CSS .orbl) y el octógono se
     encastra al final de su propio radio, .3s más tarde. BUILD_END marca el
     instante en que el último octógono termina de asentarse — el acto 2
     (pulso del núcleo + halo + ondas, ver CSS) arranca recién ahí, a los 2.3s,
     así ambos actos se leen como 2 pasos separados y no se pisan. */
  const NODE_STEP=0.14, NODE_START=0.85, NODE_DUR=0.55, LINE_LEAD=0.3;
  nodeEls.forEach((n,i)=>{ n.style.animationDelay=(NODE_START+i*NODE_STEP)+'s'; });
  lineEls.forEach((l,i)=>{ l.style.animationDelay=(NODE_START+i*NODE_STEP-LINE_LEAD)+'s'; });
  const BUILD_END = NODE_START + 7*NODE_STEP + NODE_DUR; // ≈2.38s, último octógono asentado

  /* one loop drives the float and the pulses. It idles when the hero is off screen. */
  let t=0, running=true, started=performance.now();
  const coreG=document.getElementById('orbCore');
  function frame(now){
    if(!running) return;
    t=(now-started)/1000;
    let hit=false;
    const blinking = t>BUILD_END;   /* acto 2 recién empieza acá: antes, los pulsos viajeros quedan apagados */
    geo.forEach((g,i)=>{
      const off=blinking ? Math.sin(t*0.7 + i*0.9)*3.2 : 0;   /* el leve flote también arranca junto al parpadeo */
      const {ix,iy,ox,oy}=place(i,off);
      if(!blinking){ pulseEls[i].style.opacity=0; return; }
      const ph=((t*0.28 + i*0.125) % 1);                    /* a pulse runs from the piece into the outcome */
      const px=ox+(ix-ox)*ph, py=oy+(iy-oy)*ph;
      pulseEls[i].setAttribute('cx',px.toFixed(1)); pulseEls[i].setAttribute('cy',py.toFixed(1));
      const fade=Math.min(1, Math.min(ph,1-ph)*6);
      /* v14.1 fix: .style.opacity (inline) en vez de setAttribute('opacity',…) — el
         atributo de presentación SVG queda siempre debajo de la regla de la hoja de
         estilos ".orbp{opacity:0;}" en especificidad, así que antes estos puntos de
         pulso viajero nunca se veían aunque el loop los calculaba cuadro a cuadro. */
      pulseEls[i].style.opacity=(fade*0.9).toFixed(2);
      if(ph>0.965) hit=true;   /* a pulse has just landed in the outcome */
    });
    coreG.classList.toggle('hit', hit);
    requestAnimationFrame(frame);
  }
  requestAnimationFrame(frame);

  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(e.isIntersecting && !running){ running=true; started=performance.now()-t*1000; requestAnimationFrame(frame); }
    else if(!e.isIntersecting){ running=false; }
  }),{threshold:0});
  io.observe(svg);

  /* v11.7 · pointer-follow del orb removido (Design 2 red-line). El handler seteaba
     translate(dx*16px, dy*14px) sobre #orbPar según posición del mouse dentro del hero
     rect. Design 2 pidió que el orb se quede fijo — solo mantiene sus animaciones internas
     (orbSpin/orbBreathe/orbPulse/orbRipple) sin reaccionar al pointer.
     Dead code preservado: `#orbPar{transition:transform .5s cubic-bezier(.2,.8,.3,1);}`
     en CSS línea ~2279 (patrón v9.6 · conservación). */
})();


/* the stat counts up when the hero is seen. The number is the argument. */
(function(){
  const el=document.querySelector('.hnum'); if(!el) return;
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const target=95;
  if(RMq){ el.textContent=target+'%'; return; }
  let done=false;
  const io=new IntersectionObserver(es=>es.forEach(e=>{
    if(!e.isIntersecting || done) return;
    done=true;
    const t0=performance.now(), dur=1500;
    (function step(now){
      const p=Math.min(1,(now-t0)/dur);
      const e2=1-Math.pow(1-p,3);
      el.textContent=Math.round(target*e2)+'%';
      if(p<1) requestAnimationFrame(step);
    })(t0);
  }),{threshold:.6});
  io.observe(el);
})();




/* ===== act slides (3 and 4) =====
   The same machine as the chapter: hold the frame, move through the acts.
   One act on screen at a time, so nothing is given away early. */
(function(){
  const RMq=matchMedia('(prefers-reduced-motion: reduce)').matches;
  const narrow=matchMedia('(max-width:760px)');
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));

  /* v14.6 · el bloque de init de #sstage3 (que dibujaba los 3 octagons compartidos)
     quedó removido — reemplazado por 3 stages independientes (#howstageA/B/C, ver
     HTML del #how). En su lugar, init de las 3 stages nuevas: solo hace falta
     pre-calcular el pathLength de las match lines del stage C para el drawing.
     Los stages A y B son estáticos en su estado inicial (opacity/transform en 0),
     no necesitan init. */
  try {
    document.querySelectorAll('#howstageC .s2c_ln').forEach(l => {
      const L = l.getTotalLength ? l.getTotalLength() : 130;
      l.setAttribute('stroke-dasharray', L);
      l.setAttribute('stroke-dashoffset', L);
      l.dataset.len = L;
    });
  } catch(e) {}

  function wire(trackId, railId, stageSel, onAct, progId, mobileMode, manualQuery){
    /* v20.4 · 6to param renombrado de `mobileCarousel` (bool) a `mobileMode` (tri-state):
         - false / undefined = showAll en mobile (default; usado por #how #chapter #mp3
           que colapsan a stack all-visible en mobile via el base .sslide mobile rule)
         - true = scroll-driven carousel en mobile igual que desktop (usado por #examples
           per feedback v18.8 · "esto es un carousel, debe mantenerse asi en todos los
           tamaños")
         - 'manual' = wire NO toca el estado de acts/stage/rail cuando manualQuery
           matches. Un JS externo maneja el estado del carousel manualmente (chevrons +
           dots + auto-advance). Usado por #mex desde v20.4 (P02 rework: mobile carousel
           real con tap navigation como pidió Design 2).
       Backward-compat: mobileMode === true funciona igual que mobileCarousel === true
       (mismo valor truthy que antes).
       v21.1 · 7mo param opcional `manualQuery` (MediaQueryList). Default: `narrow`
       (max-width:760). Cuando isManual=true y manualQuery.matches, el wire NO drivea
       (init render(0), frame loop). Permite que un section como #mp3 haga manual mode
       tanto en tablet como en mobile (pasando matchMedia('(max-width:1000px)')) sin
       tocar el comportamiento de otros sections que solo lo hacen en mobile. */
    const track=document.getElementById(trackId); if(!track) return;
    const prog=progId?document.getElementById(progId):null;
    const acts=[...track.querySelectorAll('.sact')];
    const rail=[...document.querySelectorAll('#'+railId+' i')];
    const stage=stageSel?[...track.querySelectorAll(stageSel)]:[];
    if(!acts.length) return;
    const isManual = mobileMode === 'manual';
    const isCarousel = mobileMode === true;
    const manualQ = manualQuery || narrow;  /* v21.1 · default: mobile-only manual */
    function showAll(){ acts.forEach(a=>a.classList.add('on')); stage.forEach(s=>s.classList.add('on')); rail.forEach(r=>r.classList.add('on')); if(prog) prog.style.width='100%'; if(onAct) onAct(acts.length-1, 1); }
    /* init: showAll en RMq o (mobile default) · skip todo en manual · scroll-drive
       en carousel-mobile o desktop */
    if(!isManual && (RMq || (narrow.matches && !isCarousel))){ showAll(); }
    function render(p){
      const n=acts.length;
      const idx=Math.min(n-1, Math.floor(p*n));
      acts.forEach((a,i)=>a.classList.toggle('on', i===idx));
      stage.forEach((s,i)=>s.classList.toggle('on', i===idx));
      rail.forEach((r,i)=>r.classList.toggle('on', i<=idx));
      if(prog) prog.style.width=(p*100).toFixed(2)+'%';
      if(onAct) onAct(idx, p);
    }
    /* the drive: sample the frame's position every animation frame while the slide is near
       the viewport. No scroll events, so it holds in Safari, in embedded previews, and
       inside any container that scrolls on a wrapper rather than the window. */
    let live=false;
    function frame(){
      if(!live) return;
      if(isManual && manualQ.matches){ /* manual mode active: external JS drives, do nothing */ }
      else if(narrow.matches && !isCarousel){ showAll(); }
      else {
        const r=track.getBoundingClientRect();
        const span=r.height-innerHeight;
        if(span>40){ render(clamp((-r.top)/span)); }
        else { showAll(); }   /* the frame cannot pin here: give everything, hide nothing */
      }
      requestAnimationFrame(frame);
    }
    if(!RMq){
      const vio=new IntersectionObserver(es=>es.forEach(e=>{
        if(e.isIntersecting && !live){ live=true; requestAnimationFrame(frame); }
        else if(!e.isIntersecting){ live=false; }
      }),{rootMargin:'30%'});
      vio.observe(track);
      /* v21.1 · skip init render(0) también cuando manual+manualQ matches, para no
         setear un estado que wireMobileCarousel va a pisar al segundo siguiente. */
      const skipInit = narrow.matches || (isManual && manualQ.matches);
      if(!skipInit || isCarousel) render(0);
    }
    const onNarrow=e=>{ if(e.matches && !isCarousel && !isManual) showAll(); };
    if(narrow.addEventListener){ narrow.addEventListener('change', onNarrow); }
    else if(narrow.addListener){ narrow.addListener(onNarrow); }
  }

  /* v14.7 · autoplay loops per-stage (feedback Design 2 · "las animaciones son
     acompañantes al texto, no podemos pretender que siga scrolleando").
     Antes v14.6 estaban scroll-driven (localP dentro del slide). Ahora cada
     stage tiene su propio timer autónomo que arranca cuando el slide se activa
     (recibe `.on`), corre el ciclo de ~6.5s, pausa ~1s, y loopea. Cuando el
     slide sale de foco, el stage pausa (y en el próximo re-entry vuelve a
     resetear desde el frame 0). wire() sigue manejando qué stage tiene `.on`
     via el 3er arg `.howstage`; nuestro onAct solo detecta cambios de idx y
     dispara start()/stop() de los loops. */

  /* v18.2 · speed 2× per feedback Design 2 · era 6500ms + 1000ms (7.5s ciclo total) →
     ahora 3250ms + 500ms (3.75s ciclo total). Más energy, más cerca del pentagon del
     intake (~2.4s one-shot). El copy de cada slide sigue siendo readable en el mismo
     tiempo de scroll — la animation acompaña más rápido. */
  const LOOP_MS = 3250, PAUSE_MS = 500;
  function segLocal(p, a, b){ return Math.min(1, Math.max(0, (p-a)/(b-a))); }

  function makeLoop(renderFn){
    let startAt = 0, running = false, rafId = 0;
    function step(now){
      if(!running) return;
      const t = (now - startAt) % (LOOP_MS + PAUSE_MS);
      const p = Math.min(1, t / LOOP_MS);
      renderFn(p);
      rafId = requestAnimationFrame(step);
    }
    return {
      start(){
        if(running) return;
        running = true;
        startAt = performance.now();
        renderFn(0);                              /* reset visible a frame 0 */
        rafId = requestAnimationFrame(step);
      },
      stop(){
        running = false;
        if(rafId){ cancelAnimationFrame(rafId); rafId = 0; }
      }
    };
  }

  const RMq2 = matchMedia('(prefers-reduced-motion: reduce)').matches;
  let stageLoops = null;   /* [loopA, loopB, loopC] · lazy init below */
  let howCurrentActive = -1;

  function initStageLoops(){
    if(stageLoops) return;
    stageLoops = [makeLoop(renderHowStageA), makeLoop(renderHowStageB), makeLoop(renderHowStageC)];
  }

  /* RM mode: sin loops, todos los stages en estado final para que se lean
     estáticos (el wire() los marca .on a los 3 en showAll). */
  if(RMq2){
    renderHowStageA(1); renderHowStageB(1); renderHowStageC(1);
  } else {
    initStageLoops();
  }

  /* Pausa todos los loops cuando el #how sale del viewport (perf + evita loops
     invisibles corriendo indefinidamente cuando el usuario ya está en otra
     sección). currentActive queda en -1 para re-triggear al volver a entrar. */
  const howSection = document.getElementById('how');
  if(howSection && !RMq2){
    new IntersectionObserver(entries => entries.forEach(e => {
      if(!e.isIntersecting){
        stageLoops && stageLoops.forEach(l => l.stop());
        howCurrentActive = -1;
      } else if(stageLoops && window.matchMedia('(max-width:760px)').matches){
        /* v24.1 · Re-entry en viewport (MOBILE ONLY): restart el loop del stage activo.
           Bug latente firmado v23.2: en mobile el scroll wire está en 'manual' mode
           (7mo param 'manual' del wire('strack3'...)) y no re-dispara render() al
           re-entrar en viewport. El wireMobileCarousel solo dispara onSlideChange en
           click de chevrons/dots, no en re-entry. Consecuencia: la primera vez que
           el user ve el #how, los .s2a_block quedan en opacity:0 (frame 0 del loop)
           para siempre hasta que se clickee un chevron. Fix: buscar el .howstage.on
           activo, marcar howCurrentActive, y kick-start el loop correspondiente.
           Desktop/tablet no necesitan esta lógica — su scroll wire dispara render(p)
           en cada frame de scroll, re-triggeando el .on toggle → stageLoops start.
           Compat: cuando wireMobileCarousel corre initMobile() DESPUÉS de esta IO
           haber disparado stop(), el onSlideChange(0) re-arranca el loop igualmente
           (idx !== howCurrentActive:-1). Este bloque es la red de contención para el
           OTRO flow: page load con #how ya out-of-viewport → IO stop → user scrollea
           al section → sin este bloque, animación nunca corre. */
        const activeStage = document.querySelector('#how .howstage.on');
        const idx = activeStage ? (parseInt(activeStage.dataset.act, 10) || 0) : 0;
        if(idx !== howCurrentActive){
          howCurrentActive = idx;
          stageLoops.forEach((l, i) => { if(i === idx) l.start(); else l.stop(); });
        }
      }
    }), {rootMargin: '10%'}).observe(howSection);
  }

  wire('strack3','srail3', '.howstage', (idx, p) => {
    /* v18.3 · sync .howev.on removed · la card volvió a la col izquierda dentro de cada
       .sact. v23.2 · sync .howcard.on agregado — el nuevo bloque .howcards (sibling del
       .cstagewrap.howstages) vive fuera del .sact para permitir el stack tablet+mobile
       con orden title/copy/animation/card. Cada .howcard cross-fade sync con el idx
       del slide activo (mismo cross-fade que .howstage y .sact). En desktop las
       .howcards están display:none (via #how .howcards{display:none} default) así que
       este toggle no tiene efecto visible ahí — solo aplica en tablet (761-1000) donde
       el wire sigue scroll-driven. En mobile <=760 el wire está en 'manual' mode (7mo
       param del wire abajo · matchMedia default 760) y wireMobileCarousel maneja el
       toggle vía onSlideChange. */
    document.querySelectorAll('#how .howcard').forEach((c, i) => c.classList.toggle('on', i === idx));
    /* v24.2 · data-slide en el section — driver del spacing/tamaño por-slide del CSS
       tablet+mobile (#how[data-slide="N"]). En desktop el attr cambia igual pero ninguna
       regla desktop lo usa (inerte). */
    if(howSection) howSection.dataset.slide = idx;
    if(RMq2) return;
    if(idx === howCurrentActive) return;    /* solo actuar en cambio de slide */
    howCurrentActive = idx;
    stageLoops.forEach((l, i) => {
      if(i === idx) l.start();
      else l.stop();
    });
  }, 'ssprog3', 'manual');

  /* v23.2 · #how mobile carousel state-driven · chevrons + dots + auto-advance 5s + tap navigation.
     Design 2 red-line: mobile debe ser carousel real, no flow-stack. Reusa wireMobileCarousel
     pattern firmado en v20.4 (#mex), v20.5 (#mco), v21.1 (#mp3). Params:
     · hasCards:false porque #how no tiene .excard (los cards son .howcard, manejados vía callback)
     · activeQuery default (max-width:760) — solo mobile · tablet sigue con wire scroll-driven
     · onSlideChange: sync .howstage.on + .howcard.on + trigger de animation loop del stage activo */
  wireMobileCarousel('how', {
    hasCards: false,
    autoAdvance: false,   /* v23.3 · Design 2 red-line: ningún carousel debe reproducirse automaticamente */
    onSlideChange: (idx) => {
      document.querySelectorAll('#how .howstage').forEach((s, i) => s.classList.toggle('on', i === idx));
      document.querySelectorAll('#how .howcard').forEach((c, i) => c.classList.toggle('on', i === idx));
      if(howSection) howSection.dataset.slide = idx;   /* v24.2 · spacing por-slide CSS */
      if(idx !== howCurrentActive){
        howCurrentActive = idx;
        stageLoops.forEach((l, i) => { if(i === idx) l.start(); else l.stop(); });
      }
    }
  });

  /* --- Stage A · pipeline · 4 cards secuenciales (INPUT → RULES → AGENT → GATE) --- */
  function renderHowStageA(p){
    const restX = [30, 112, 194, 276];
    const anchors = [0.10, 0.30, 0.50, 0.70];
    document.querySelectorAll('#howstageA .s2a_block').forEach((b, i) => {
      const s = segLocal(p, anchors[i], anchors[i]+0.10);
      b.setAttribute('opacity', s);
      b.setAttribute('transform', `translate(${restX[i]},${180 - (1-s)*14})`);
    });
  }

  /* --- Stage B · ladder · spine + rungs 01/02/03 + v1.0 top-down sumatoria --- */
  function renderHowStageB(p){
    const spine = document.querySelector('#howstageB #s2b_spine');
    const rungs = document.querySelectorAll('#howstageB .s2b_rung');
    const end = document.querySelector('#howstageB #s2b_end');
    if (!spine || !end) return;
    const yPos = [60, 140, 220];
    /* spine grows top-down */
    const sp = segLocal(p, 0.05, 0.60);
    spine.setAttribute('stroke-dashoffset', 250*(1-sp));
    /* rungs 01/02/03 top-down */
    const anchors = [0.08, 0.26, 0.44];
    rungs.forEach((r, i) => {
      const s = segLocal(p, anchors[i], anchors[i]+0.12);
      r.setAttribute('opacity', s);
      r.setAttribute('transform', `translate(0,${yPos[i] - (1-s)*10})`);
    });
    /* 4ta rung · v1.0 · misma animación que las otras */
    const es = segLocal(p, 0.62, 0.74);
    end.setAttribute('opacity', es);
    end.setAttribute('transform', `translate(0,${300 - (1-es)*10})`);
  }

  /* --- Stage C · match · 2 panels + 3 crossing lines + ports "pegados" --- */
  function renderHowStageC(p){
    const left = document.querySelector('#howstageC #s2c_left');
    const right = document.querySelector('#howstageC #s2c_right');
    const leftPortsG = document.querySelector('#howstageC #s2c_left_ports');
    const rightPortsG = document.querySelector('#howstageC #s2c_right_ports');
    if (!left || !right) return;
    /* left panel + ports (misma transform + opacity) */
    const ls = segLocal(p, 0.05, 0.22);
    const leftT = `translate(${20 - (1-ls)*30},60)`;
    left.setAttribute('opacity', ls);
    left.setAttribute('transform', leftT);
    leftPortsG.setAttribute('opacity', ls);
    leftPortsG.setAttribute('transform', leftT);
    /* right panel + ports */
    const rs = segLocal(p, 0.18, 0.36);
    const rightT = `translate(${244 + (1-rs)*30},60)`;
    right.setAttribute('opacity', rs);
    right.setAttribute('transform', rightT);
    rightPortsG.setAttribute('opacity', rs);
    rightPortsG.setAttribute('transform', rightT);
    /* match lines · dibujadas en secuencia */
    const anchors = [0.42, 0.56, 0.70];
    document.querySelectorAll('#howstageC .s2c_ln').forEach((l, i) => {
      const s = segLocal(p, anchors[i], anchors[i]+0.10);
      const L = +l.dataset.len || 130;
      l.setAttribute('stroke-dashoffset', L*(1-s));
    });
  }
  wire('strack4','srail4', '.excard', null, 'ssprog4', true);  /* v18.8 · mobileCarousel:true · restore carousel behavior on mobile per feedback Design 2 */
  wire('mtrack1','mrail1', '.excard', null, 'mprog1', 'manual');  /* v20.4 · mobileMode:'manual' · el mex-carousel wire de más abajo maneja el estado del carousel en mobile (chevrons + dots + auto-advance) */
  wire('mtrack2','mrail2', null, (idx,p)=>{ if(window.cycleSet) window.cycleSet(p); }, 'mprog2', 'manual');  /* v20.5 · mobileMode:'manual' · wireMobileCarousel('mco',...) maneja el estado en mobile */
  /* v16.4 · onAct setea `data-slide` en #mp3 con el idx activo (0 o 1). Usado por
     CSS `#mp3[data-slide="0"] .crail{display:none}` — el slide 0 tiene sus propias
     dashes DENTRO del SVG viewBox (Figma-accurate position), así que hide el crail
     externo. Slide 1 mantiene el crail visible en bottom:44.
     v21.1 · 7mo param matchMedia('(max-width:1000px)') extiende el manual mode a
     tablet+mobile — antes el wire seguía scroll-driveando en tablet (aunque isManual)
     porque el default de manualQ era narrow (760px). Ahora tablet+mobile son ambos
     manejados por wireMobileCarousel('mp3',...) abajo. */
  wire('mtrack3','mrail3', '.excard', (idx)=>{
    const mp3 = document.getElementById('mp3');
    if(mp3) mp3.setAttribute('data-slide', idx);
  }, 'mprog3', 'manual', matchMedia('(max-width:1000px)'));
})();

/* ===== the pinned chapter: 100 pilots, 95 fade, 5 become the record =====
   Four acts, one viewport of scroll each, back to back. Every pixel of scroll
   moves something: there is no dead ground to get stuck in. */
(function(){
  const track=document.getElementById('ctrack'); if(!track) return;
  const field=document.getElementById('field'), rec=document.getElementById('crec'),
        rows=[...document.querySelectorAll('#crec .crow')],
        fieldLbl=document.getElementById('cfieldlbl'),
        acts=[...document.querySelectorAll('.cact')], rail=[...document.querySelectorAll('#crail i')];
  const clamp=(v,a=0,b=1)=>Math.min(b,Math.max(a,v));
  const seg=(p,s,e)=>clamp((p-s)/(e-s));
  const ease=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;

  const COLS=10, GAP=52, R=15, X0=450-((COLS-1)*GAP)/2, Y0=150;
  const SURV=[13,27,46,62,81];
  const marks=[]; let html='';
  for(let i=0;i<100;i++){
    const cx=X0+(i%COLS)*GAP, cy=Y0+Math.floor(i/COLS)*GAP;
    let d='';
    for(let k=0;k<8;k++){const a=(-90+22.5+k*45)*Math.PI/180; d+=(k?'L':'M')+(cx+R*Math.cos(a)).toFixed(1)+' '+(cy+R*Math.sin(a)).toFixed(1)+' ';}
    const isS=SURV.includes(i);
    html+=`<path class="mk${isS?' surv':''}" d="${d}Z" fill="none" stroke="#856B5A" stroke-width="2.5" opacity="0"/>`;
    marks.push({cx,cy,isS});
  }
  field.innerHTML=html;
  const mk=[...field.querySelectorAll('.mk')];

  /* v11.4 · target-position cache: los 5 .cro dots del record (uno por row) son el
     destino final donde aterrizan los 5 survivors en act 4. Se computan una vez a partir
     del DOM y se cachean; se re-computan si el layout cambia (resize). */
  let CRO_TARGETS=null;
  function computeCroTargets(){
    const svg=document.getElementById('cstage');
    if(!svg) return null;
    const svgRect=svg.getBoundingClientRect();
    if(svgRect.width<10||svgRect.height<10) return null;
    const vb=svg.viewBox.baseVal;
    const sx=vb.width/svgRect.width, sy=vb.height/svgRect.height;
    const croEls=document.querySelectorAll('#crec .cro');
    if(croEls.length!==5) return null;
    return [...croEls].map(cro=>{
      const r=cro.getBoundingClientRect();
      return {
        x: vb.x + (r.left + r.width/2 - svgRect.left) * sx,
        y: vb.y + (r.top + r.height/2 - svgRect.top) * sy
      };
    });
  }
  addEventListener('resize', ()=>{ CRO_TARGETS=null; }, {passive:true});

  function render(p){
    const idx = p<0.25?0 : p<0.5?1 : p<0.75?2 : 3;
    acts.forEach((a,i)=>a.classList.toggle('on', i===idx));
    rail.forEach((r,i)=>r.classList.toggle('on', i<=idx));
    const a1=seg(p,0.00,0.25), a2=seg(p,0.25,0.50), a3=seg(p,0.50,0.75), a4=seg(p,0.75,1.00);

    /* v11.4 · lazy-cache de los targets. Se computa la primera vez que entra act 4
       (los .cro ya están en el DOM desde el load; .crow opacity:0 no afecta layout). */
    if(a4>0 && !CRO_TARGETS) CRO_TARGETS=computeCroTargets();

    mk.forEach((m,i)=>{
      const d=marks[i];
      const arrive=clamp((a1*118 - i)/14);
      let o=arrive, stroke='#856B5A', sw=2.5, tr='';
      if(d.isS){
        const ti=SURV.indexOf(i);
        o=Math.max(arrive, a2>0?1:arrive);
        stroke = a2>0.12 ? '#FF7F6B' : '#856B5A';
        sw = a2>0.12 ? 3.5 : 2.5;
        if(a3>0 && a4<=0){
          /* Act 3 stand-alone: translate to vertical column at x=450 */
          const e=ease(a3);
          tr=`translate(${((450-d.cx)*e).toFixed(1)},${(((Y0+126)+ti*54-d.cy)*e).toFixed(1)})`;
        }
        if(a4>0){
          /* v11.4 · Act 4: los 5 survivors continúan su journey desde la columna vertical
             (x=450, y=Y0+126+ti*54) hasta la posición exacta de cada .cro del record. Shrink
             de radius 15 → 4.5 (scale 0.3×) para matchear el tamaño del .cro (9×9 = R 4.5).
             FILL-IN durante el primer 0.05 de act 4 (p=0.75..0.80): pasan de outline (fill:none,
             stroke:spark, sw:3.5) a filled solid (fill:spark, sw:0) — matchea visualmente al .cro
             que es octagon sólido con clip-path. Fade out escalonado matched al fade-in de cada row
             → seamless crossover: el survivor se apaga exactamente donde el .cro se enciende. */
          const startX=450, startY=Y0+126+ti*54;
          const target=(CRO_TARGETS&&CRO_TARGETS[ti])||{x:startX,y:startY};
          const landing=ease(seg(p,0.75,0.90));
          const nowX=startX+(target.x-startX)*landing;
          const nowY=startY+(target.y-startY)*landing;
          const scale=1-0.7*landing;
          /* Compose: SVG transform "translate(dx,dy) scale(s)" aplica scale primero
             (alrededor del origen 0,0 del SVG), después translate. El path del mark está
             definido alrededor de (d.cx, d.cy). Post-scale queda en (d.cx*s, d.cy*s).
             Translate por (dx,dy) = (nowX - d.cx*s, nowY - d.cy*s) → lo lleva a (nowX, nowY). */
          const dx=nowX-d.cx*scale, dy=nowY-d.cy*scale;
          tr=`translate(${dx.toFixed(1)},${dy.toFixed(1)}) scale(${scale.toFixed(3)})`;
          /* fill-in transition: outline → filled. fillOp anima 0→1 en p=0.75..0.80 */
          const fillOp=ease(seg(p,0.75,0.80));
          m.setAttribute('fill','#FF7F6B');
          m.setAttribute('fill-opacity',fillOp.toFixed(3));
          /* stroke se reduce en paralelo (3.5 outline → 0 al estar fully filled) y también
             se escala con el size shrinkage */
          sw=3.5*scale*(1-fillOp);
          /* v11.5 · el survivor NO fade-out — se queda al 100% opacity una vez aterrizado.
             ES el .cro del row (visualmente idéntico, misma position, mismo tamaño). Si fadeaba,
             el alpha blending con el .cro fading-in creaba un dip de brillo ~75% en el mid-cross
             que se leía como "el dot se apaga y vuelve". Ahora survivor stay at 1 → dot siempre
             visible al 100%, y el .cro del row aparece encima como redundancia invisible (mismo
             fill, misma shape). El "writing" del row emerge SOLO del texto. */
          o=1;
        } else {
          /* v11.4 · fuera de act 4: reset fill a none (los survivors act 1-3 son outline) */
          m.setAttribute('fill','none');
          m.setAttribute('fill-opacity','1');
        }
      } else {
        const fade=ease(a2);
        o=arrive*(1-fade*0.95);
        tr=`translate(0,${(fade*16).toFixed(1)})`;
        if(a3>0) o=arrive*(1-ease(a3))*0.05;
      }
      m.setAttribute('opacity', o.toFixed(3));
      m.setAttribute('stroke', stroke);
      m.setAttribute('stroke-width', sw);
      m.setAttribute('transform', tr);
    });

    if(fieldLbl) fieldLbl.style.opacity=(1-ease(seg(p,0.5,0.62))).toFixed(3);
    /* v11.6 · card materializa DESPUÉS de que landing done (p=0.90..0.94). Antes empezaba
       a 0.83 (overlap con landing) — el bg opaco tapaba al survivor mientras aterrizaba,
       obscureciendo el dot. Ahora la card llega después: survivor aterriza limpio, después
       la card + los .cro emergen juntos, después el texto se escribe. */
    const cardT=ease(seg(p,0.90,0.94));
    rec.style.opacity=cardT.toFixed(3);
    /* v11.6 · row visibility split en 2 fases:
       (a) .cro (el dot marker del row) fadea CON la card — así el dot marker aparece encima
           del survivor exactamente cuando la card bg lo obscurece. Sin gap visible.
           Se logra seteando row.style.opacity = cardT (afecta a todos los children incluido .cro).
       (b) Texto (b + i) writes in staggered per row — cada uno tiene su propia opacity inline,
           que compone con la row opacity (multiplicación de alpha compositing). Row 0 empieza
           a p=0.94 (justo cuando cardT reaches 1). Stagger 0.008, duration 0.04 → row 4 ends
           at 1.004, casi exacto p=1.00. */
    rows.forEach((row,i)=>{
      row.style.opacity=cardT.toFixed(3);
      row.style.transform='none';
      const textT=ease(seg(p, 0.94+i*0.008, 0.97+i*0.008));
      const b=row.querySelector('b'), em=row.querySelector('i');
      if(b) b.style.opacity=textT.toFixed(3);
      if(em) em.style.opacity=textT.toFixed(3);
    });
  }

  /* the drive: frame sampling, the same mechanism as slides 3 and 4 */
  let live=false;
  function frame(){
    if(!live) return;
    const r=track.getBoundingClientRect();
    const span=r.height-innerHeight;
    if(span>40) render(clamp((-r.top)/span));
    requestAnimationFrame(frame);
  }
  if(RM){ render(1); }
  else {
    const vio=new IntersectionObserver(es=>es.forEach(e=>{
      if(e.isIntersecting && !live){ live=true; requestAnimationFrame(frame); }
      else if(!e.isIntersecting){ live=false; }
    }),{rootMargin:'30%'});
    vio.observe(track);
    render(0);
  }
})();

/* v20.4 · Reusable mobile carousel wire para las secciones pinned de /mission
   (#mex, #mco, #mp3). Activo cuando matchMedia('(max-width:760px)').matches.
   En tablet/desktop el pinned scroll (wire()) sigue manejando el estado — este
   JS no toca los .on classes fuera de mobile. Auto-advance 5s + pause on tap +
   IntersectionObserver para pausar cuando off-viewport.
   v20.5 · refactor de la IIFE-específica-a-#mex a función reusable con opts.
   Opts.onSlideChange(idx, p) callback opcional — usado por #mco para llamar
   cycleSet(p) que dibuja el octágono progresivamente. Opts.hasCards (default true)
   controla si se togglea .on en .excard (mex sí las tiene · mco no, tiene una sola
   SVG persistente sin cards separadas). */
function wireMobileCarousel(sectionId, opts){
  /* v20.4 · Carousel state-driven para mobile (chevrons + dots + auto-advance 5s +
     tap navigation). Base pattern usado por #mex, #mco, #mp3.
     v21.1 · opts.activeQuery (MediaQueryList) override del default (max-width:760).
     Usado por #mp3 con matchMedia('(max-width:1000px)') para extender el carousel a
     tablet también — Design 2 pidió "flechas + puntitos como en mobile" en tablet
     también, además de mobile. La función se llama igual (wireMobileCarousel), el
     naming histórico refleja el pattern original mobile-only.
     v21.3 · opts.autoAdvance:false disables el auto-advance timer. Default true
     (backward-compat: mex/mco/stays/mcommit siguen con auto-advance como estaban).
     Usado por #mp3 desde v21.3 per Design 2: "no debe reproducirse automaticamente,
     el usuario tendrá que scrollear o utilizar las flechas para moverlo". */
  opts = opts || {};
  const section = document.getElementById(sectionId);
  if(!section) return;
  const acts = [...section.querySelectorAll('.sact')];
  const cards = opts.hasCards !== false ? [...section.querySelectorAll('.excard')] : [];
  const controls = section.querySelector('.ss-carousel-controls');
  if(!controls) return;
  const prevBtn = controls.querySelector('.ss-prev');
  const nextBtn = controls.querySelector('.ss-next');
  const dots = [...controls.querySelectorAll('.ss-dot')];
  const N = acts.length;
  if(!N) return;
  if(opts.hasCards !== false && cards.length !== N) return;
  const INTERVAL_MS = 5000;
  const mobileQuery = opts.activeQuery || window.matchMedia('(max-width:760px)');
  const autoAdvance = opts.autoAdvance !== false;   /* v21.3 · default true; false disables el timer */
  let current = 0;
  let autoTimer = null;
  let inViewport = false;

  function isMobile(){ return mobileQuery.matches; }

  function setActive(idx){
    if(!isMobile()) return;
    current = ((idx % N) + N) % N;
    acts.forEach((a,i) => a.classList.toggle('on', i === current));
    if(cards.length) cards.forEach((c,i) => c.classList.toggle('on', i === current));
    dots.forEach((d,i) => d.classList.toggle('on', i === current));
    /* v20.5 · optional callback para secciones que necesitan lógica extra al
       cambiar de slide (ej: #mco necesita disparar cycleSet(p) para animar el
       octágono). p ∈ [0,1] mapeando idx sobre N-1. */
    if(typeof opts.onSlideChange === 'function'){
      const p = N > 1 ? current / (N - 1) : 0;
      opts.onSlideChange(current, p);
    }
  }
  function startAuto(){
    stopAuto();
    if(!autoAdvance || !inViewport || !isMobile()) return;
    autoTimer = setInterval(() => setActive(current + 1), INTERVAL_MS);
  }
  function stopAuto(){
    if(autoTimer){ clearInterval(autoTimer); autoTimer = null; }
  }
  if(prevBtn) prevBtn.addEventListener('click', () => { setActive(current - 1); startAuto(); });
  if(nextBtn) nextBtn.addEventListener('click', () => { setActive(current + 1); startAuto(); });
  dots.forEach(d => d.addEventListener('click', () => { setActive(+d.dataset.slide); startAuto(); }));

  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        inViewport = e.isIntersecting;
        if(isMobile()){
          if(inViewport) startAuto(); else stopAuto();
        }
      });
    }, {threshold: 0.3});
    io.observe(section);
  } else {
    inViewport = true;
  }

  function initMobile(){
    if(isMobile()){
      setActive(0);
      if(inViewport) startAuto();
    } else {
      stopAuto();
    }
  }
  if(mobileQuery.addEventListener){
    mobileQuery.addEventListener('change', initMobile);
  } else if(mobileQuery.addListener){
    mobileQuery.addListener(initMobile);
  }
  initMobile();
}

/* v20.4 · #mex mobile carousel · 3 slides con text + excard cards */
wireMobileCarousel('mex', {autoAdvance: false});   /* v23.3 · Design 2 red-line: ningún carousel debe reproducirse automaticamente */

/* v20.5 · #mco mobile carousel · 3 slides con text + octágono progresivo
   (sin excards, la SVG es una sola que muta via cycleSet(p)). */
wireMobileCarousel('mco', {
  hasCards: false,
  autoAdvance: false,   /* v23.3 · Design 2 red-line: ningún carousel debe reproducirse automaticamente */
  onSlideChange: (idx, p) => {
    /* cycleSet lee: p=0 → 0 labels, p=1 → 8 labels + core + resolved.
       Mapping: idx 0→p 0, idx 1→p 0.5, idx 2→p 1. Match el behavior
       del scroll-driven wire donde render(p) llama cycleSet(p) con el
       progreso del scroll (0→1 lineal). */
    if(window.cycleSet) window.cycleSet(p);
  }
});

/* v20.6 · #mp3 mobile carousel · 2 slides con excard cards. Además setea
   data-slide en la section para replicar el behavior del scroll wire
   (que usa data-slide para toggle del crail via CSS).
   v21.1 · activeQuery extendido a (max-width:1000px) para incluir tablet.
   Design 2 firmó "flechas + puntitos como en mobile" también en tablet, entonces
   el carousel state-driven maneja ambos rangos. El wire('mtrack3'...) recibe
   su propia manualQuery del mismo rango para no drivear scroll en tablet.
   v21.3 · autoAdvance:false — Design 2: "no debe reproducirse automaticamente,
   el usuario tendrá que scrollear o utilizar las flechas para moverlo". El
   #mp3 se movía solo cada 5s en tablet+mobile (a diferencia de #mex/#mco que
   solo lo hacen en mobile porque tienen activeQuery más estrecho); ahora #mp3
   requiere click explícito en chevrons o dots. */
wireMobileCarousel('mp3', {
  activeQuery: matchMedia('(max-width:1000px)'),
  autoAdvance: false,
  onSlideChange: (idx) => {
    const mp3 = document.getElementById('mp3');
    if(mp3) mp3.setAttribute('data-slide', idx);
  }
});

/* v19.1 · #stays carousel wire · sigue el pattern del #mcommit wire (v15.10/v16.11)
   adaptado a 5 slides individuales (no pairs). Dots + chevrons + auto-advance 5s +
   pause-on-hover + IntersectionObserver para pausar cuando off-viewport. */
(function(){
  const section  = document.getElementById('stays');
  if(!section) return;
  const cardsWrap = section.querySelector('.stays-cards');
  const pager     = section.querySelector('.stays-pager');
  const prevBtn   = section.querySelector('.stays-prev');
  const nextBtn   = section.querySelector('.stays-next');
  if(!cardsWrap || !pager) return;
  const slides = [...cardsWrap.querySelectorAll('.stays-slide')];
  const dots   = [...pager.querySelectorAll('.stays-dot')];
  const N = slides.length;
  const INTERVAL_MS = 5000;
  let current = 0;
  let autoTimer = null;
  let inViewport = false;

  function setActive(idx){
    current = ((idx % N) + N) % N;   // wrap negatives too
    slides.forEach(s => s.classList.toggle('on', +s.dataset.slide === current));
    dots.forEach(d => d.classList.toggle('on', +d.dataset.slide === current));
  }
  function startAuto(){
    /* v23.3 · Design 2 red-line: ningún carousel debe reproducirse automaticamente ·
       disabled el timer del #stays para consistency con el resto. Los click handlers
       de chevrons/dots siguen call-eando startAuto() pero ahora es no-op. */
    stopAuto();
    return;
  }
  function stopAuto(){
    if(autoTimer){ clearInterval(autoTimer); autoTimer = null; }
  }
  if(prevBtn) prevBtn.addEventListener('click', () => { setActive(current - 1); startAuto(); });
  if(nextBtn) nextBtn.addEventListener('click', () => { setActive(current + 1); startAuto(); });
  dots.forEach(d => d.addEventListener('click', () => { setActive(+d.dataset.slide); startAuto(); }));
  // Pause on hover
  const hoverArea = section.querySelector('.stays-bottom');
  if(hoverArea){
    hoverArea.addEventListener('mouseenter', stopAuto);
    hoverArea.addEventListener('mouseleave', () => { if(inViewport) startAuto(); });
  }
  // IntersectionObserver
  if('IntersectionObserver' in window){
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => {
        inViewport = e.isIntersecting;
        if(inViewport) startAuto(); else stopAuto();
      });
    }, {threshold: 0.3});
    io.observe(section);
  } else {
    inViewport = true;
    startAuto();
  }
})();

/* v18.12 · #who interactive map · click en cualquier octagon → info card in-map.
   Zero backdrop-filter, zero modal, zero movimiento del octagon (feedback Design 2
   acumulado v3→v4). Toggle: click misma node cierra. ESC cierra. Click fuera cierra.
   v25.2 · Reset zoom cuando se abre una card (para que el popup no quede desplazado
   por un pan/zoom activo del usuario). */
(function(){
  const map = document.getElementById('whoMap');
  if(!map) return;
  const idle    = document.getElementById('whomapIdle');
  const nodes   = map.querySelectorAll('[data-node]');
  const cards   = map.querySelectorAll('.whocard[data-node-card]');
  const closers = map.querySelectorAll('.whocard-close');
  const labels  = map.querySelectorAll('.wholabel');
  const conns   = map.querySelectorAll('[data-conn]');
  const CONN_MAP = {
    outcome:[], d1:['d1'], d2:['d2'], d3:['d3'],
    ceo:['ceo','d1'], ops:['ops','d2'], finance:['finance','d2'],
    founder:['founder','d3'], cio:['cio','d3']
  };
  let activeId = null;
  function activate(id){
    if(activeId === id){ clear(); return; }
    activeId = id;
    map.classList.add('has-active');
    // v25.2 · dispatch event so the zoom module can reset if needed
    map.dispatchEvent(new CustomEvent('who:activate', { detail: { id } }));
    nodes.forEach(n => n.classList.toggle('active', n.dataset.node === id));
    labels.forEach(l => l.classList.toggle('wholabel-active', l.dataset.label === id));
    const liveSet = new Set(CONN_MAP[id] || []);
    conns.forEach(c => c.classList.toggle('whoconn-live', liveSet.has(c.dataset.conn)));
    idle.classList.add('hide');
    cards.forEach(c => c.classList.toggle('on', c.dataset.nodeCard === id));
  }
  function clear(){
    activeId = null;
    map.classList.remove('has-active');
    nodes.forEach(n => n.classList.remove('active'));
    labels.forEach(l => l.classList.remove('wholabel-active'));
    conns.forEach(c => c.classList.remove('whoconn-live'));
    cards.forEach(c => c.classList.remove('on'));
    idle.classList.remove('hide');
  }
  nodes.forEach(n => n.addEventListener('click', e => {
    e.stopPropagation();
    activate(n.dataset.node);
  }));
  closers.forEach(b => b.addEventListener('click', e => { e.stopPropagation(); clear(); }));
  document.addEventListener('keydown', e => { if(e.key === 'Escape') clear(); });
  const section = document.getElementById('who');
  if(section){
    section.addEventListener('click', e => {
      if(!activeId) return;
      if(e.target.closest('.whocard')) return;
      if(e.target.closest('a')) return;
      clear();
    });
  }
})();

/* v25.2 · #who responsive · viewBox swap + pinch-zoom/pan (mobile-only).
   (1) viewBox swap: recorta el aire vacío horizontal del SVG a <=900px (viewBox
       "100 0 820 720", aspect 1.139) vs desktop original "0 0 1200 720" (aspect
       1.667). Doble beneficio: mapa más alto a mismo ancho + centrado del contenido
       en su bounding box (útil para zoom-from-center).
   (2) Pinch/pan mobile <=600px: 2-fingers pinch escala 1x–3x, 1-finger pan cuando
       scale>1, double-tap reset a 1x. Transform via CSS vars (--wm-scale/tx/ty).
       Touch-action alterna pan-y (permite scroll de página) ↔ none (custom pan sin
       conflicto) al pasar de scale 1 a scale>1.
   (3) Reset zoom cuando se activa una card (via 'who:activate' event) → el popup
       overlay siempre aparece con el mapa en su vista neutra. */
(function(){
  const map = document.getElementById('whoMap');
  const svg = map && map.querySelector('.whomap-svg');
  if (!svg) return;

  const VB_FULL = '0 0 1200 720';
  const VB_CROP = '100 0 820 720';
  function updateViewBox(){
    const narrow = window.innerWidth <= 900;
    svg.setAttribute('viewBox', narrow ? VB_CROP : VB_FULL);
  }
  updateViewBox();
  window.addEventListener('resize', updateViewBox);

  let scale = 1, tx = 0, ty = 0;
  const MIN = 1, MAX = 3;
  let lastDist = null, panStart = null;
  let lastTapTime = 0, lastTapX = 0, lastTapY = 0;

  function isPhone(){ return window.innerWidth <= 600; }
  function apply(){
    svg.style.setProperty('--wm-scale', scale.toFixed(3));
    svg.style.setProperty('--wm-tx', tx.toFixed(1) + 'px');
    svg.style.setProperty('--wm-ty', ty.toFixed(1) + 'px');
    map.classList.toggle('zoomed', scale > 1.02);
  }
  function clamp(){
    const rect = map.getBoundingClientRect();
    const maxTX = Math.max(0, (scale - 1) * rect.width / 2);
    const maxTY = Math.max(0, (scale - 1) * rect.height / 2);
    tx = Math.max(-maxTX, Math.min(maxTX, tx));
    ty = Math.max(-maxTY, Math.min(maxTY, ty));
  }
  function reset(){ scale = 1; tx = 0; ty = 0; apply(); }

  map.addEventListener('touchstart', (e) => {
    if (!isPhone()) return;
    if (e.touches.length === 2) {
      e.preventDefault();
      const [a, b] = e.touches;
      lastDist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
      panStart = null;
    } else if (e.touches.length === 1) {
      const t = e.touches[0];
      // Double-tap detection (only when not already zoomed OR to reset)
      const now = Date.now();
      const dt = now - lastTapTime;
      const dx = t.clientX - lastTapX, dy = t.clientY - lastTapY;
      if (dt < 320 && Math.hypot(dx, dy) < 32) {
        e.preventDefault();
        reset();
        lastTapTime = 0;
        panStart = null;
      } else {
        lastTapTime = now; lastTapX = t.clientX; lastTapY = t.clientY;
        if (scale > 1) {
          e.preventDefault();
          panStart = { x: t.clientX - tx, y: t.clientY - ty };
        }
      }
    }
  }, { passive: false });

  map.addEventListener('touchmove', (e) => {
    if (!isPhone()) return;
    if (e.touches.length === 2 && lastDist) {
      e.preventDefault();
      const [a, b] = e.touches;
      const dist = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
      scale = Math.max(MIN, Math.min(MAX, scale * dist / lastDist));
      lastDist = dist;
      clamp();
      apply();
    } else if (e.touches.length === 1 && panStart && scale > 1) {
      e.preventDefault();
      tx = e.touches[0].clientX - panStart.x;
      ty = e.touches[0].clientY - panStart.y;
      clamp();
      apply();
    }
  }, { passive: false });

  map.addEventListener('touchend', (e) => {
    if (e.touches.length < 2) lastDist = null;
    if (e.touches.length === 0) panStart = null;
  });
  map.addEventListener('touchcancel', () => { lastDist = null; panStart = null; });

  // Reset when a card opens (popup should appear over a neutral map)
  map.addEventListener('who:activate', reset);
  // Reset when leaving mobile breakpoint
  window.addEventListener('resize', () => { if (!isPhone()) reset(); });
})();

/* v25.7 · FAQ accordion (single-open) · click toggle aria-expanded en el button,
   cierra los otros. La animación de height la maneja el CSS via grid-template-rows
   swap 0fr → 1fr (ver #faq .faq-a). Zero measurement JS. */
(function(){
  const faq = document.getElementById('faq');
  if(!faq) return;
  const buttons = faq.querySelectorAll('.faq-q');
  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      buttons.forEach(b => b.setAttribute('aria-expanded', 'false'));
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });
})();

// hero card cursor tilt
const tw=document.querySelector('.tiltwrap');
if(tw && !RM && matchMedia('(pointer:fine)').matches){
  tw.addEventListener('mousemove',e=>{
    const r=tw.getBoundingClientRect();
    const x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
    tw.style.transform=`perspective(900px) rotateY(${(x*8).toFixed(2)}deg) rotateX(${(-y*8).toFixed(2)}deg)`;
  });
  tw.addEventListener('mouseleave',()=>{tw.style.transform='perspective(900px)';});
}

/* ===== hamburger menu ===== */
/* v0.57 · hamburger menu · open / close / esc / resize */
(function(){
  const toggle = document.querySelector('.navtoggle');
  const panel  = document.getElementById('mobilenav');
  if(!toggle || !panel) return;
  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('navlocked', open);
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  };
  toggle.addEventListener('click', () => {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });
  panel.querySelectorAll('a').forEach(l => l.addEventListener('click', () => setOpen(false)));
  const closeBtn = panel.querySelector('.mobilenav-close');
  if(closeBtn) closeBtn.addEventListener('click', () => setOpen(false));
  /* tapping the panel outside the inner content also closes */
  panel.addEventListener('click', (e) => {
    if(e.target === panel) setOpen(false);
  });
  document.addEventListener('keydown', (e) => {
    if(e.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') setOpen(false);
  });
  const mq = window.matchMedia('(min-width: 1024px)');
  const handleMq = (m) => { if(m.matches) setOpen(false); };
  if(mq.addEventListener) mq.addEventListener('change', handleMq); else mq.addListener(handleMq);
})();
